<template>
  <div class="container-area-personale studio-management-page">
    <aside class="studio-management-sidebar" aria-label="Sezioni dello studio">
      <div class="studio-sidebar-hero">
        <div class="studio-sidebar-icon">
          <i class="fa-solid fa-building" aria-hidden="true"></i>
        </div>
        <h3>{{ studio?.nome || "Il tuo studio" }}</h3>
      </div>

      <div class="studio-sidebar-divider"></div>

      <nav
        class="studio-sidebar-navigation"
        aria-label="Sezioni del gestionale"
      >
        <button
          type="button"
          class="studio-sidebar-nav-item"
          :class="{ active: activeAdminPanel === 'studio' }"
          :aria-current="activeAdminPanel === 'studio' ? 'page' : null"
          @click="selectPanel('studio')"
        >
          <i class="fa-solid fa-house"></i>
          <span>Panoramica</span>
        </button>
        <button
          type="button"
          class="studio-sidebar-nav-item"
          :class="{ active: activeAdminPanel === 'clienti' }"
          :aria-current="activeAdminPanel === 'clienti' ? 'page' : null"
          @click="selectPanel('clienti')"
        >
          <i class="fa-solid fa-address-book"></i>
          <span>Anagrafica Clienti</span>
        </button>
        <button
          type="button"
          class="studio-sidebar-nav-item"
          :class="{ active: activeAdminPanel === 'archivio' }"
          :aria-current="activeAdminPanel === 'archivio' ? 'page' : null"
          @click="selectPanel('archivio')"
        >
          <i class="fa-solid fa-box-archive"></i>
          <span>Archivio file convertiti</span>
        </button>

        <div
          v-if="isAdminOrMyStudioAdmin"
          class="studio-sidebar-admin-navigation"
          role="group"
          aria-label="Funzioni di amministrazione"
        >
          <div class="studio-sidebar-nav-section-label">
            <span>Amministrazione</span>
          </div>
          <button
            type="button"
            class="studio-sidebar-nav-item"
            :class="{ active: activeAdminPanel === 'utenti' }"
            :aria-current="activeAdminPanel === 'utenti' ? 'page' : null"
            @click="selectPanel('utenti')"
          >
            <i class="fa-solid fa-users"></i>
            <span>Utenze</span>
          </button>
          <button
            type="button"
            class="studio-sidebar-nav-item"
            :class="{ active: activeAdminPanel === 'files' }"
            :aria-current="activeAdminPanel === 'files' ? 'page' : null"
            @click="selectPanel('files')"
          >
            <i class="fa-solid fa-folder-tree"></i>
            <span>Librerie dello studio</span>
          </button>
          <button
            type="button"
            class="studio-sidebar-nav-item"
            :class="{ active: activeAdminPanel === 'account' }"
            :aria-current="activeAdminPanel === 'account' ? 'page' : null"
            @click="openStudioAccountPanel"
          >
            <i class="fa-solid fa-gear"></i>
            <span>Account Studio</span>
          </button>
        </div>
      </nav>
    </aside>

    <section class="studio-management-main" aria-label="Area studio">
      <header
        class="area-page-header area-page-header--management area-page-header--section"
        aria-labelledby="management-section-title"
      >
        <span
          class="area-page-header__icon area-page-header__icon--section"
          aria-hidden="true"
        >
          <i :class="activePanelMeta.icon"></i>
        </span>
        <div class="area-page-header__copy">
          <h1 id="management-section-title" class="area-page-header__title">
            {{ activePanelMeta.title }}
          </h1>
          <p class="area-page-header__subtitle">
            {{ activePanelMeta.subtitle }}
          </p>
        </div>
        <img
          class="area-page-header__visual area-page-header__visual--management"
          src="/Titoli pagine/Immagine Area Gestionale.png"
          alt=""
          aria-hidden="true"
        />
      </header>

      <div class="main-content studio-management-content">
        <div class="studio-panel-viewport">
          <div v-show="activeAdminPanel === 'studio'" class="studio-panel">
            <template v-if="!isLoading && studio">
              <div class="studio-dashboard">
                <!-- Statistiche in card -->
                <div class="studio-stats">
                  <span class="title-cards">Piano dello studio</span>
                  <div class="stat-row">
                    <div
                      class="stat-card stat-card-iconic stat-card-plan-highlight"
                    >
                      <i class="fa-solid fa-graduation-cap stat-icon"></i>
                      <span class="stat-label">Piano attuale</span>
                      <span class="stat-value">
                        <span v-if="currentPlan === 'base'">Base</span>
                        <span v-else-if="currentPlan === 'plus'">Plus</span>
                        <span v-else-if="currentPlan === 'premium'"
                          >Premium</span
                        >
                        <span v-else>—</span>
                      </span>
                    </div>

                    <div
                      class="stat-card stat-card-iconic stat-card-coin-highlight"
                    >
                      <i class="fa-solid fa-coins stat-icon"></i>
                      <span class="stat-label">Coin disponibili</span>
                      <span class="stat-value coin">{{
                        studio.crediti_disponibili
                      }}</span>
                    </div>

                    <div class="stat-card stat-card-iconic">
                      <i class="fa-regular fa-calendar stat-icon"></i>
                      <span class="stat-label">Inizio Piano</span>
                      <span class="stat-value">{{
                        dataInizio ? formatDate(dataInizio) : "—"
                      }}</span>
                    </div>

                    <div class="stat-card stat-card-iconic">
                      <i class="fa-regular fa-calendar-check stat-icon"></i>
                      <span class="stat-label">Scadenza Piano</span>
                      <span class="stat-value">{{
                        dataScadenza ? formatDate(dataScadenza) : "—"
                      }}</span>
                    </div>
                  </div>
                  <span class="title-cards">Statistiche</span>
                  <div class="stat-row">
                    <div
                      class="stat-card stat-card-statistiche stat-card-statistiche--converter stat-card-statistiche--prospetti stat-card-iconic"
                    >
                      <span class="stat-icon" aria-hidden="true">
                        <ProductIcon product="prospetti" />
                      </span>
                      <span class="stat-label">Prospetti Paghe convertiti</span>
                      <span class="stat-value">{{
                        studio.conversioni_effettuate_prospetti
                      }}</span>
                    </div>

                    <div
                      class="stat-card stat-card-statistiche stat-card-statistiche--converter stat-card-statistiche--f24 stat-card-iconic"
                    >
                      <span class="stat-icon" aria-hidden="true">
                        <ProductIcon product="f24" />
                      </span>
                      <span class="stat-label">Modelli F24 convertiti</span>
                      <span class="stat-value">{{
                        studio.conversioni_effettuate_f24
                      }}</span>
                    </div>

                    <div
                      class="stat-card stat-card-statistiche stat-card-statistiche--converter stat-card-statistiche--bilanci stat-card-iconic"
                    >
                      <span class="stat-icon" aria-hidden="true">
                        <ProductIcon product="bilancio" />
                      </span>
                      <span class="stat-label"
                        >Bilanci Analitici convertiti</span
                      >
                      <span class="stat-value">{{
                        studio.conversioni_effettuate_bilanci
                      }}</span>
                    </div>

                    <button
                      type="button"
                      class="stat-card stat-card-statistiche stat-card-iconic stat-card-link stat-card-documents"
                      title="Vai all'archivio dei file convertiti"
                      @click="selectPanel('archivio')"
                    >
                      <span
                        class="stat-icon studio-aggregate-icon"
                        aria-hidden="true"
                      >
                        <span class="studio-aggregate-tools">
                          <ProductIcon product="prospetti" />
                          <ProductIcon product="f24" />
                          <ProductIcon product="bilancio" />
                        </span>
                        <i
                          class="fa-solid fa-folder-open studio-aggregate-folder"
                        ></i>
                      </span>
                      <span class="stat-label">Documenti convertiti</span>
                      <span class="stat-value">{{
                        studioConvertedDocumentsTotal
                      }}</span>
                    </button>
                  </div>
                  <span class="title-cards">Registrazione</span>
                  <div class="stat-row">
                    <div class="stat-card stat-card-registrazione">
                      <span class="stat-label"
                        >Data di Registrazione Studio</span
                      >
                      <span class="stat-value">{{
                        formatDate(studio.data_registrazione)
                      }}</span>
                    </div>
                    <div class="stat-card stat-card-registrazione">
                      <span class="stat-label">Utenti registrati</span>
                      <button
                        type="button"
                        class="stat-value studio-users-trigger"
                        title="Mostra gli utenti dello studio"
                        @click="showStudioUsersModal = true"
                      >
                        {{ registeredUsersCount }}
                      </button>
                    </div>
                    <!-- Chiave di registrazione (un po' più evidenziata) -->
                    <div
                      v-if="isAdminOrMyStudioAdmin"
                      class="stat-card stat-card-registrazione key-card"
                    >
                      <span class="stat-label">
                        Chiave di Registrazione
                        <span class="info-icon info-icon-clean">
                          <i
                            class="fa-solid fa-circle-info info-icon-software"
                            aria-hidden="true"
                          ></i>
                          <span class="tooltip">
                            Passala ad un utente per registrarsi a MyStudio
                          </span>
                        </span>
                      </span>
                      <div class="key-actions">
                        <i
                          class="fa-solid fa-key key-icon"
                          title="Mostra chiave"
                          @click="showKeyModal = true"
                        ></i>
                        <i
                          class="fa-regular fa-copy copy-icon"
                          title="Copia chiave"
                          @click="copyRegistrationKey('card')"
                        ></i>
                        <span
                          v-if="copySuccess && copyFeedbackLocation === 'card'"
                          class="copy-feedback copy-message"
                        >
                          {{ copySuccess }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="showKeyModal && isAdminOrMyStudioAdmin"
                class="modal-overlay-key"
              >
                <div class="modal-content-key">
                  <h3>Chiave di Registrazione</h3>
                  <p v-if="!isEditing" class="keystudio">
                    {{ studio.registration_key }}
                  </p>
                  <div v-if="isEditing" class="edit-key-form">
                    <label for="new-key">Nuova chiave:</label>
                    <input
                      id="new-key"
                      type="text"
                      v-model="newRegistrationKey"
                      placeholder="Inserisci la nuova chiave (alfanumerica, 5-36 caratteri)"
                      class="input-field"
                      @input="clearMessages"
                    />
                    <div v-if="errorMessage" class="error-message">
                      {{ errorMessage }}
                    </div>
                    <div v-if="successMessage" class="success-message">
                      {{ successMessage }}
                    </div>
                  </div>
                  <div class="modal-buttons">
                    <button
                      v-if="!isEditing && isAdminOrMyStudioAdmin"
                      class="modal-btn-edit"
                      @click="startEditing"
                    >
                      Modifica
                    </button>
                    <button
                      v-if="isEditing"
                      class="modal-btn-save"
                      @click="saveNewKey"
                      :disabled="isLoading || !isValidKey"
                    >
                      <span v-if="isLoading">
                        <div class="spinner"></div>
                        Salvataggio...
                      </span>
                      <span v-else>Salva</span>
                    </button>
                    <button class="modal-btn-close" @click="closeModal">
                      {{ isEditing ? "Annulla" : "Chiudi" }}
                    </button>
                  </div>
                </div>
              </div>

              <div
                v-if="showStudioUsersModal"
                class="modal-overlay-key"
                @click.self="showStudioUsersModal = false"
              >
                <section
                  class="studio-users-modal"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="studio-users-title"
                >
                  <div class="studio-users-modal-header">
                    <div>
                      <h3 id="studio-users-title">Utenti dello studio</h3>
                      <p>{{ studio.nome }}</p>
                    </div>
                    <button
                      type="button"
                      class="studio-users-close"
                      aria-label="Chiudi elenco utenti"
                      @click="showStudioUsersModal = false"
                    >
                      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                    </button>
                  </div>
                  <ul
                    v-if="studioUserProfiles.length"
                    class="studio-users-list"
                  >
                    <li
                      v-for="(utente, index) in studioUserProfiles"
                      :key="utente.email"
                    >
                      <span
                        class="users-profile-avatar studio-users-avatar"
                        :class="`users-profile-avatar--${(index % 5) + 1}`"
                        aria-hidden="true"
                      >
                        {{ userInitials(utente) }}
                      </span>
                      <span class="users-profile-copy studio-users-profile">
                        <strong>{{ studioUserDisplayName(utente) }}</strong>
                        <small>{{ utente.email }}</small>
                      </span>
                    </li>
                  </ul>
                  <p v-else class="studio-users-empty">
                    Nessun utente registrato.
                  </p>
                </section>
              </div>
            </template>

            <template v-else-if="isLoading">
              <div class="studio-skeleton admin-dashboard-skeleton">
                <div class="admin-skeleton-header">
                  <div class="skeleton admin-skeleton-icon"></div>
                  <div class="admin-skeleton-heading-lines">
                    <div class="skeleton admin-skeleton-title"></div>
                    <div class="skeleton admin-skeleton-subtitle"></div>
                  </div>
                </div>

                <div
                  v-for="section in 3"
                  :key="`admin-skeleton-section-${section}`"
                  class="admin-skeleton-section"
                >
                  <div class="skeleton admin-skeleton-section-title"></div>
                  <div class="admin-skeleton-card-row">
                    <div
                      v-for="card in section === 3 ? 3 : 4"
                      :key="`admin-skeleton-card-${section}-${card}`"
                      class="admin-skeleton-card"
                    >
                      <div class="skeleton admin-skeleton-card-label"></div>
                      <div class="skeleton admin-skeleton-card-value"></div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <div
            v-if="activeAdminPanel === 'clienti'"
            class="embedded-panel embedded-panel-card"
          >
            <AnagraficaClienti ref="clientiPanel" embedded />
          </div>

          <div v-if="activeAdminPanel === 'archivio'" class="embedded-panel">
            <ArchivioFileConvertiti embedded />
          </div>

          <section
            v-if="isAdminOrMyStudioAdmin && activeAdminPanel === 'account'"
            class="studio-account-panel"
            aria-labelledby="studio-account-title"
          >
            <form
              class="studio-account-card"
              @submit.prevent="saveStudioAccount"
            >
              <header class="studio-account-header">
                <div>
                  <h2 id="studio-account-title">Dati identificativi</h2>
                </div>
              </header>

              <div class="studio-account-body">
                <div class="studio-account-field">
                  <label for="studio-vat-number">Partita IVA</label>
                  <input
                    id="studio-vat-number"
                    v-model.trim="studioAccount.partita_iva"
                    type="text"
                    inputmode="numeric"
                    pattern="[0-9]{11}"
                    maxlength="11"
                    placeholder="01234567890"
                    required
                  />
                </div>
                <div class="studio-account-field">
                  <label for="studio-address">Indirizzo sede</label>
                  <input
                    id="studio-address"
                    v-model.trim="studioAccount.indirizzo_sede"
                    type="text"
                    maxlength="255"
                    placeholder="Via Roma 10"
                    required
                  />
                </div>
                <div class="studio-account-location-grid">
                  <div class="studio-account-field">
                    <label for="studio-postal-code">CAP</label>
                    <input
                      id="studio-postal-code"
                      v-model.trim="studioAccount.cap"
                      type="text"
                      inputmode="numeric"
                      pattern="[0-9]{5}"
                      maxlength="5"
                      placeholder="20100"
                      required
                    />
                  </div>
                  <div class="studio-account-field">
                    <label for="studio-city">Città</label>
                    <input
                      id="studio-city"
                      v-model.trim="studioAccount.citta"
                      type="text"
                      maxlength="100"
                      placeholder="Milano"
                      required
                    />
                  </div>
                  <div class="studio-account-field">
                    <label for="studio-province">Provincia</label>
                    <input
                      id="studio-province"
                      v-model.trim="studioAccount.provincia"
                      type="text"
                      pattern="[A-Za-z]{2}"
                      maxlength="2"
                      placeholder="MI"
                      class="studio-account-uppercase"
                      required
                    />
                  </div>
                </div>

                <p
                  v-if="studioAccountError"
                  class="studio-account-feedback error"
                >
                  <i class="fa-solid fa-circle-exclamation"></i>
                  {{ studioAccountError }}
                </p>
              </div>

              <footer class="studio-account-actions">
                <button
                  type="button"
                  class="studio-account-secondary"
                  :disabled="
                    savingStudioAccount || !hasUnsavedStudioAccountChanges
                  "
                  @click="resetStudioAccount"
                >
                  Ripristina
                </button>
                <button
                  type="submit"
                  class="studio-account-primary"
                  :disabled="
                    savingStudioAccount || !hasUnsavedStudioAccountChanges
                  "
                >
                  <span v-if="savingStudioAccount">Salvataggio...</span>
                  <span v-else>Salva dati studio</span>
                </button>
              </footer>
            </form>
          </section>

          <div
            v-if="isAdminOrMyStudioAdmin && activeAdminPanel === 'utenti'"
            class="table-container2"
          >
            <!-- Modal per registrazione utente -->
            <div
              v-if="mostraFormRegistrazione"
              class="modal-overlay2"
              @click.self="mostraFormRegistrazione = false"
            >
              <div
                class="user-registration-form modal-content2 registration-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="registrationModalTitle"
              >
                <div class="registration-modal-header">
                  <div>
                    <h3 id="registrationModalTitle" class="formtitle">
                      <i class="fa-solid fa-user-plus"></i>
                      Registra un nuovo utente in MyStudio
                    </h3>
                    <p class="formsubtitle">
                      {{ studio?.nome || "Caricamento..." }}
                    </p>
                  </div>
                  <button
                    type="button"
                    class="registration-close-btn"
                    @click="mostraFormRegistrazione = false"
                    title="Chiudi"
                  >
                    &times;
                  </button>
                </div>

                <div
                  v-if="erroreRegistrazione"
                  class="registration-banner error"
                >
                  <i class="fa-solid fa-circle-exclamation"></i>
                  {{ erroreRegistrazione }}
                </div>

                <div
                  v-if="confermaRegistrazione"
                  class="registration-banner success"
                >
                  <i class="fa-solid fa-circle-check"></i>
                  Utente registrato con successo
                </div>

                <form
                  class="registration-modal-form"
                  @submit.prevent="registraUtente"
                >
                  <div class="registration-grid">
                    <div class="registration-field">
                      <label for="register-user-first-name">
                        Nome <span class="required">*</span>
                      </label>
                      <input
                        id="register-user-first-name"
                        v-model="newUser.firstName"
                        placeholder="Inserisci il nome"
                        type="text"
                        required
                      />
                    </div>

                    <div class="registration-field">
                      <label for="register-user-last-name">
                        Cognome <span class="required">*</span>
                      </label>
                      <input
                        id="register-user-last-name"
                        v-model="newUser.lastName"
                        placeholder="Inserisci il cognome"
                        type="text"
                        required
                      />
                    </div>
                  </div>

                  <div class="registration-field">
                    <label for="register-user-email">
                      Email <span class="required">*</span>
                    </label>
                    <input
                      id="register-user-email"
                      v-model="newUser.email"
                      placeholder="nome@studio.it"
                      type="email"
                      required
                    />
                  </div>

                  <div v-if="studio?.is_test_studio" class="registration-field">
                    <label for="register-user-account-type">
                      Tipo utenza <span class="required">*</span>
                    </label>
                    <select
                      id="register-user-account-type"
                      v-model="newUser.accountType"
                    >
                      <option value="real">
                        Utente reale con invito email
                      </option>
                      <option value="test">
                        Utente test con password MyStudio
                      </option>
                    </select>
                  </div>

                  <div
                    v-if="newUser.accountType === 'test'"
                    class="registration-grid registration-password-grid"
                  >
                    <div class="registration-field password-container">
                      <label for="register-user-password">
                        Password test <span class="required">*</span>
                      </label>
                      <input
                        id="register-user-password"
                        :type="showPassword ? 'text' : 'password'"
                        v-model="newUser.password"
                        placeholder="Password per login diretto"
                        required
                      />
                      <i
                        :class="
                          showPassword
                            ? 'fa-solid fa-eye'
                            : 'fa-solid fa-eye-slash'
                        "
                        @click="showPassword = !showPassword"
                        class="toggle-password-icon"
                      ></i>
                    </div>

                    <div class="registration-field password-container">
                      <label for="register-user-confirm-password">
                        Conferma password <span class="required">*</span>
                      </label>
                      <input
                        id="register-user-confirm-password"
                        :type="showPassword ? 'text' : 'password'"
                        v-model="newUser.confirmPassword"
                        placeholder="Ripeti la password"
                        required
                      />
                      <i
                        :class="
                          showPassword
                            ? 'fa-solid fa-eye'
                            : 'fa-solid fa-eye-slash'
                        "
                        @click="showPassword = !showPassword"
                        class="toggle-password-icon"
                      ></i>
                    </div>
                  </div>

                  <div v-else class="registration-info-box">
                    <i class="fa-solid fa-shield-halved"></i>
                    <span>
                      L'utente riceverà un invito via email. Al primo accesso
                      confermerà il proprio indirizzo email e sceglierà la
                      password.
                    </span>
                  </div>

                  <div class="registration-actions">
                    <button
                      type="button"
                      class="registration-btn cancel"
                      :disabled="loadingRegistrazione"
                      @click="mostraFormRegistrazione = false"
                    >
                      Annulla
                    </button>
                    <button
                      type="submit"
                      class="registration-btn primary"
                      :disabled="loadingRegistrazione"
                    >
                      <span
                        v-if="loadingRegistrazione"
                        class="registration-loading-label"
                      >
                        <span class="registration-spinner"></span>
                        Registrazione in corso...
                      </span>
                      <span v-else>
                        <i class="fa-solid fa-user-plus"></i>
                        Registra utente
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div class="users-directory-body">
              <div class="users-directory-toolbar">
                <div class="users-directory-filters">
                  <label class="users-search-field">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <input
                      v-model.trim="userSearchQuery"
                      type="search"
                      placeholder="Cerca utente o email..."
                      aria-label="Cerca utente o email"
                    />
                  </label>
                  <label class="users-role-filter">
                    <i class="fa-solid fa-filter"></i>
                    <select
                      v-model="userRoleFilter"
                      aria-label="Filtra utenti per ruolo"
                    >
                      <option value="all">Tutti i ruoli</option>
                      <option value="admin">Admin</option>
                      <option value="utente">Utenti</option>
                    </select>
                  </label>
                </div>

                <div class="table-actions users-directory-actions">
                  <button
                    @click="mostraFormRegistrazione = true"
                    class="toggle-form-btn users-register-button"
                  >
                    <i class="fa-solid fa-plus"></i> Registra nuovo utente
                  </button>
                  <button @click="scaricaExcelUtenti" class="download-btn">
                    <i class="fa-solid fa-download"></i> Scarica tabella utenti
                  </button>
                  <button
                    @click="salvaTutteModifiche"
                    :disabled="!hasUnsavedChanges"
                    class="save-all-btn"
                    title="Salva tutte le modifiche"
                  >
                    <i class="fa-solid fa-floppy-disk"></i> Salva tutto
                  </button>
                </div>
              </div>

              <div class="users-table-scroll users-directory-table-scroll">
                <table class="usertable users-directory-table">
                  <thead>
                    <tr>
                      <th aria-label="Numero riga"></th>
                      <th>Profilo</th>
                      <th>Ruolo</th>
                      <th>Permessi</th>
                      <th>Stato e Attività</th>
                      <th>Azioni</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="isLoading">
                      <tr v-for="n in 5" :key="n">
                        <td><div class="skeleton-cell"></div></td>
                        <td><div class="skeleton-cell"></div></td>
                        <td><div class="skeleton-cell"></div></td>
                        <td><div class="skeleton-cell"></div></td>
                        <td><div class="skeleton-cell"></div></td>
                        <td><div class="skeleton-cell action"></div></td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr
                        v-for="(utente, index) in filteredUtenti"
                        :key="utente.email"
                      >
                        <td class="users-row-number">{{ index + 1 }}</td>
                        <td>
                          <div class="users-profile-cell">
                            <span
                              class="users-profile-avatar"
                              :class="`users-profile-avatar--${
                                (index % 5) + 1
                              }`"
                            >
                              {{ userInitials(utente) }}
                            </span>
                            <span class="users-profile-copy">
                              <strong>{{ userFullName(utente) }}</strong>
                              <small>{{ utente.email }}</small>
                            </span>
                          </div>
                        </td>
                        <td>
                          <span
                            v-if="utente.ruolo_originale === 'adminMyStudio'"
                            class="admin-fixed users-role-fixed"
                          >
                            <img
                              class="users-role-logo"
                              src="/Pagina%20Welcome/logo.png"
                              alt=""
                              aria-hidden="true"
                            />
                            adminMS
                          </span>
                          <select
                            v-else
                            v-model="utente.ruolo"
                            @change="handleUserRoleChange(utente)"
                            :disabled="utente.email === userEmail"
                            class="users-role-select"
                            :class="{
                              'input-modificato':
                                utente.ruolo !== utente.ruolo_originale,
                              'users-role-select--admin':
                                utente.ruolo === 'admin',
                            }"
                          >
                            <option value="admin">admin</option>
                            <option value="utente">utente</option>
                          </select>
                        </td>
                        <td>
                          <div class="users-permissions-cell">
                            <label class="users-permission-row">
                              <span class="switch">
                                <input
                                  type="checkbox"
                                  v-model="utente.puo_fare_acquisti"
                                  :disabled="utente.ruolo === 'admin'"
                                />
                                <span
                                  class="slider"
                                  :class="{
                                    modificato:
                                      utente.puo_fare_acquisti !==
                                      utente.puo_fare_acquisti_originale,
                                  }"
                                ></span>
                              </span>
                              <span>Acquisti in App</span>
                            </label>
                            <label
                              class="users-permission-row"
                              title="Permette di modificare impostazioni condivise dello studio da pagina Impostazioni"
                            >
                              <span class="switch">
                                <input
                                  type="checkbox"
                                  :checked="
                                    effectiveCanManageStudioSettings(utente)
                                  "
                                  :disabled="utente.ruolo === 'admin'"
                                  @change="
                                    setCanManageStudioSettings(
                                      utente,
                                      $event.target.checked
                                    )
                                  "
                                />
                                <span
                                  class="slider"
                                  :class="{
                                    modificato:
                                      effectiveCanManageStudioSettings(
                                        utente
                                      ) !==
                                      originalEffectiveCanManageStudioSettings(
                                        utente
                                      ),
                                  }"
                                ></span>
                              </span>
                              <span>Impostazioni in App</span>
                            </label>
                          </div>
                        </td>
                        <td>
                          <div class="users-activity-cell">
                            <span class="users-registration-date">
                              <i class="fa-regular fa-calendar"></i>
                              {{ formatDate(utente.data_registrazione) }}
                              <button
                                v-if="utente.auth_provider === 'pending_clerk'"
                                @click="reinviaInvitoUtente(utente)"
                                class="btn-azione btn-invito"
                                title="Reinvia invito"
                              >
                                <i class="fa-solid fa-paper-plane"></i>
                              </button>
                            </span>
                            <span class="conversioni-cell">
                              <button
                                type="button"
                                class="conversioni-total users-conversions-pill"
                                :aria-expanded="
                                  activeConversionDetails === utente.email
                                "
                                @click.stop="
                                  toggleConversionDetails(utente.email, $event)
                                "
                                :aria-label="`Conversioni totali: ${totaleConversioniUtente(
                                  utente
                                )}. Mostra dettaglio conversioni`"
                              >
                                <i class="fa-solid fa-chart-simple"></i>
                                {{ totaleConversioniUtente(utente) }}
                                conversioni
                              </button>
                              <div
                                v-if="activeConversionDetails === utente.email"
                                class="conversioni-popover"
                                :style="conversionPopoverStyle"
                                role="status"
                              >
                                <strong>Conversioni</strong>
                                <span>
                                  Prospetti Paghe
                                  <b>{{
                                    utente.conversioni_effettuate_prospetti
                                  }}</b>
                                </span>
                                <span>
                                  Modelli F24
                                  <b>{{ utente.conversioni_effettuate_f24 }}</b>
                                </span>
                                <span>
                                  Bilanci Analitici
                                  <b>{{
                                    utente.conversioni_effettuate_bilanci
                                  }}</b>
                                </span>
                              </div>
                            </span>
                            <button
                              @click="
                                ha(user, 'cronologia_operazioni')
                                  ? apriStoricoOperazioni(utente.email)
                                  : null
                              "
                              class="storico-btn users-history-button"
                              :class="{
                                bloccato: !ha(user, 'cronologia_operazioni'),
                              }"
                              :title="
                                ha(user, 'cronologia_operazioni')
                                  ? ha(user, 'cronologia_illimitata')
                                    ? 'Vedi cronologia completa'
                                    : 'Vedi ultime 10 operazioni'
                                  : 'Cronologia disponibile da piano Plus'
                              "
                              :disabled="!ha(user, 'cronologia_operazioni')"
                            >
                              <i class="fa-solid fa-clock-rotate-left"></i>
                              <span>Storico</span>
                              <i
                                v-if="!ha(user, 'cronologia_operazioni')"
                                class="fa-solid fa-lock users-history-lock"
                              ></i>
                            </button>
                          </div>
                        </td>
                        <td>
                          <div class="actions-menu-wrapper">
                            <button
                              class="btn-azione btn-menu-utente users-action-button"
                              title="Azioni utente"
                              :aria-expanded="
                                activeUserActionsMenu === utente.email
                              "
                              @click.stop="
                                toggleUserActionsMenu(utente, $event)
                              "
                            >
                              <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <div
                              v-if="activeUserActionsMenu === utente.email"
                              class="user-actions-dropdown"
                              :style="userActionsMenuStyle"
                            >
                              <button @click="apriDettagliUtente(utente)">
                                Visualizza dettagli
                              </button>
                              <button
                                v-if="canResetTestUserPassword(utente)"
                                @click="apriResetPasswordTest(utente)"
                              >
                                Reset password
                              </button>
                              <button
                                v-else-if="
                                  utente.auth_provider === 'pending_clerk'
                                "
                                @click="reinviaInvitoUtente(utente)"
                              >
                                Reinvia invito
                              </button>
                              <button
                                v-else-if="canConvertUserToTest(utente)"
                                @click="apriConversioneUtenteTest(utente)"
                              >
                                Rendi utente test
                              </button>
                              <button
                                v-else-if="utente.auth_provider === 'clerk'"
                                @click="mostraInfoResetClerk(utente)"
                              >
                                Invia reset password
                              </button>
                              <button
                                class="danger"
                                :disabled="utente.ruolo_originale === 'admin'"
                                @click="chiediConfermaElimina(utente)"
                              >
                                Elimina utente
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="filteredUtenti.length === 0">
                        <td colspan="6" class="users-empty-state">
                          <i class="fa-solid fa-user-slash"></i>
                          Nessun utente corrisponde ai filtri selezionati.
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="users-table-scroll users-table-legacy">
              <table class="usertable">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Email</th>
                    <th>Ruolo</th>
                    <th>Acquisti in App</th>
                    <th>
                      Impostazioni<br />in App
                      <span class="info-icon-operations">
                        <i
                          class="fa-solid fa-circle-info info-icon-software"
                        ></i>
                        <span class="tooltip">
                          Permette di modificare impostazioni condivise dello
                          studio da pagina Impostazioni
                        </span>
                      </span>
                    </th>
                    <th class="compact-date-col">Data registrazione</th>
                    <th class="compact-conversions-col">Conversioni</th>
                    <th>
                      Storico Operazioni
                      <span
                        v-if="ha(user, 'cronologia_operazioni')"
                        class="info-icon-operations"
                      >
                        <i
                          class="fa-solid fa-circle-info info-icon-software"
                        ></i>
                        <span class="tooltip">
                          <template v-if="!ha(user, 'cronologia_illimitata')">
                            Cronologia delle ultime 10 operazioni · Piano Plus
                          </template>
                          <template v-else>
                            Cronologia completa di tutte le operazioni · Piano
                            Premium
                          </template>
                        </span>
                      </span>
                      <!-- Lucchetto nel titolo se Base -->
                      <i
                        v-if="!ha(user, 'cronologia_operazioni')"
                        class="fa-solid fa-lock lock-icon"
                        title="Disponibile da piano Plus"
                        style="margin-left: 6px"
                      ></i>
                    </th>
                    <th>Azioni</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="isLoading">
                    <tr v-for="n in 5" :key="n">
                      <td><div class="skeleton-cell"></div></td>
                      <td><div class="skeleton-cell"></div></td>
                      <td><div class="skeleton-cell"></div></td>
                      <td><div class="skeleton-cell"></div></td>
                      <td><div class="skeleton-cell"></div></td>
                      <td><div class="skeleton-cell"></div></td>
                      <td><div class="skeleton-cell"></div></td>
                      <td><div class="skeleton-cell"></div></td>
                      <td><div class="skeleton-cell action"></div></td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr v-for="utente in utenti" :key="utente.email">
                      <td>{{ userFullName(utente) }}</td>
                      <td>{{ utente.email }}</td>
                      <td>
                        <span
                          v-if="utente.ruolo_originale === 'adminMyStudio'"
                          class="admin-fixed users-role-fixed"
                        >
                          <img
                            class="users-role-logo"
                            src="/Pagina%20Welcome/logo.png"
                            alt=""
                            aria-hidden="true"
                          />
                          adminMS
                        </span>
                        <select
                          v-else
                          v-model="utente.ruolo"
                          @change="handleUserRoleChange(utente)"
                          :disabled="utente.email === userEmail"
                          :class="{
                            'input-modificato':
                              utente.ruolo !== utente.ruolo_originale,
                            'users-role-select--admin':
                              utente.ruolo === 'admin',
                          }"
                        >
                          <option value="admin">admin</option>
                          <option value="utente">utente</option>
                        </select>
                      </td>
                      <td>
                        <label class="switch">
                          <input
                            type="checkbox"
                            v-model="utente.puo_fare_acquisti"
                            :disabled="utente.ruolo === 'admin'"
                          />
                          <span
                            class="slider"
                            :class="{
                              modificato:
                                utente.puo_fare_acquisti !==
                                utente.puo_fare_acquisti_originale,
                            }"
                            title="Permette di fare acquisti dallo Store"
                          ></span>
                        </label>
                      </td>
                      <td>
                        <label
                          class="switch"
                          title="Permette di modificare impostazioni condivise dello studio da pagina Impostazioni"
                        >
                          <input
                            type="checkbox"
                            :checked="effectiveCanManageStudioSettings(utente)"
                            :disabled="utente.ruolo === 'admin'"
                            @change="
                              setCanManageStudioSettings(
                                utente,
                                $event.target.checked
                              )
                            "
                          />
                          <span
                            class="slider"
                            :class="{
                              modificato:
                                effectiveCanManageStudioSettings(utente) !==
                                originalEffectiveCanManageStudioSettings(
                                  utente
                                ),
                            }"
                          ></span>
                        </label>
                      </td>
                      <td>
                        <div class="registration-date-cell">
                          <span>{{
                            formatDate(utente.data_registrazione)
                          }}</span>
                          <button
                            v-if="utente.auth_provider === 'pending_clerk'"
                            @click="reinviaInvitoUtente(utente)"
                            class="btn-azione btn-invito"
                            title="Reinvia invito"
                          >
                            <i class="fa-solid fa-paper-plane"></i>
                          </button>
                        </div>
                      </td>
                      <td>
                        <div class="conversioni-cell">
                          <button
                            type="button"
                            class="conversioni-total"
                            :aria-expanded="
                              activeConversionDetails === utente.email
                            "
                            @click.stop="
                              toggleConversionDetails(utente.email, $event)
                            "
                            :aria-label="`Conversioni totali: ${totaleConversioniUtente(
                              utente
                            )}. Mostra dettaglio conversioni`"
                          >
                            {{ totaleConversioniUtente(utente) }}
                          </button>
                          <div
                            v-if="activeConversionDetails === utente.email"
                            class="conversioni-popover"
                            :style="conversionPopoverStyle"
                            role="status"
                          >
                            <strong>Conversioni</strong>
                            <span>
                              Prospetti Paghe
                              <b>{{
                                utente.conversioni_effettuate_prospetti
                              }}</b>
                            </span>
                            <span>
                              Modelli F24
                              <b>{{ utente.conversioni_effettuate_f24 }}</b>
                            </span>
                            <span>
                              Bilanci Analitici
                              <b>{{ utente.conversioni_effettuate_bilanci }}</b>
                            </span>
                          </div>
                        </div>
                      </td>
                      <td class="text-center">
                        <button
                          @click="
                            ha(user, 'cronologia_operazioni')
                              ? apriStoricoOperazioni(utente.email)
                              : null
                          "
                          class="storico-btn"
                          :class="{
                            bloccato: !ha(user, 'cronologia_operazioni'),
                          }"
                          :title="
                            ha(user, 'cronologia_operazioni')
                              ? ha(user, 'cronologia_illimitata')
                                ? 'Vedi cronologia completa'
                                : 'Vedi ultime 10 operazioni'
                              : 'Cronologia disponibile da piano Plus'
                          "
                          :disabled="!ha(user, 'cronologia_operazioni')"
                        >
                          <i class="fa-solid fa-clock-rotate-left"></i>
                        </button>
                      </td>
                      <td>
                        <div class="actions-menu-wrapper">
                          <button
                            class="btn-azione btn-menu-utente"
                            title="Azioni utente"
                            :aria-expanded="
                              activeUserActionsMenu === utente.email
                            "
                            @click.stop="toggleUserActionsMenu(utente, $event)"
                          >
                            <i class="fa-solid fa-ellipsis"></i>
                          </button>
                          <div
                            v-if="activeUserActionsMenu === utente.email"
                            class="user-actions-dropdown"
                            :style="userActionsMenuStyle"
                          >
                            <button @click="apriDettagliUtente(utente)">
                              Visualizza dettagli
                            </button>
                            <button
                              v-if="canResetTestUserPassword(utente)"
                              @click="apriResetPasswordTest(utente)"
                            >
                              Reset password
                            </button>
                            <button
                              v-else-if="
                                utente.auth_provider === 'pending_clerk'
                              "
                              @click="reinviaInvitoUtente(utente)"
                            >
                              Reinvia invito
                            </button>
                            <button
                              v-else-if="canConvertUserToTest(utente)"
                              @click="apriConversioneUtenteTest(utente)"
                            >
                              Rendi utente test
                            </button>
                            <button
                              v-else-if="utente.auth_provider === 'clerk'"
                              @click="mostraInfoResetClerk(utente)"
                            >
                              Invia reset password
                            </button>
                            <button
                              class="danger"
                              :disabled="utente.ruolo_originale === 'admin'"
                              @click="chiediConfermaElimina(utente)"
                            >
                              Elimina utente
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <transition name="fade">
              <div
                v-if="storicoModalVisibile"
                class="modal-overlay"
                @click.self="chiudiStoricoModal"
              >
                <div class="modal-content-storico">
                  <h3>Ultime operazioni di {{ storicoModalUtenteEmail }}</h3>
                  <button class="close-btn" @click="chiudiStoricoModal">
                    ×
                  </button>
                  <table class="download-log-table">
                    <thead>
                      <tr>
                        <th>Tipo di Operazione</th>
                        <th>File Caricato</th>
                        <th>File Elaborato</th>
                        <th>Data Operazione</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="isLoadingStorico">
                        <td colspan="4" class="operationtext">
                          <div class="loader-wrapper">
                            <div class="loader"></div>
                            <span>Caricamento in corso...</span>
                          </div>
                        </td>
                      </tr>
                      <tr v-else-if="storicoOperazioni.length === 0">
                        <td colspan="4" class="operationtext">
                          Nessuna operazione effettuata.
                        </td>
                      </tr>
                      <template v-for="log in storicoOperazioni">
                        <tr :key="log.id">
                          <td>{{ log.operazione }}</td>
                          <td>
                            <button
                              v-if="hasUploadedArchivedFile(log)"
                              :class="[
                                'archived-file-link',
                                { disabled: !canDownloadArchivedFiles() },
                              ]"
                              @click.stop="downloadUploadedArchivedFile(log)"
                            >
                              {{ getUploadedArchivedFileLabel(log) }}
                            </button>
                            <template v-else>{{ log.file_name }}</template>
                          </td>
                          <td
                            @click="
                              log.file_scaricati &&
                              log.file_scaricati.length > 1
                                ? toggleExpand(log.id)
                                : null
                            "
                            :class="{
                              'clickable-cell':
                                (log.file_scaricati &&
                                  log.file_scaricati.length > 1) ||
                                hasArchivedFiles(log),
                            }"
                          >
                            <template v-if="Array.isArray(log.file_scaricati)">
                              <template v-if="log.file_scaricati.length === 1">
                                <button
                                  v-if="hasArchivedFiles(log)"
                                  :class="[
                                    'archived-file-link',
                                    { disabled: !canDownloadArchivedFiles() },
                                  ]"
                                  @click.stop="downloadArchivedFile(log, 0)"
                                >
                                  {{ getArchivedFileLabel(log, 0) }}
                                </button>
                                <template v-else>
                                  {{ log.file_scaricati[0] }}
                                </template>
                              </template>
                              <template
                                v-else-if="log.file_scaricati.length > 1"
                              >
                                <span class="chip"
                                  >📁 {{ log.file_scaricati.length }} file</span
                                >
                              </template>
                              <template v-else>Nessun file scaricato</template>
                            </template>
                            <template v-else>Nessun file scaricato</template>
                          </td>
                          <td>{{ formatDate(log.download_date) }}</td>
                        </tr>
                        <tr
                          v-if="isExpanded(log.id)"
                          :key="'expanded-' + log.id"
                        >
                          <td colspan="4" class="expanded-row">
                            <span class="filescaricatititle"
                              >File scaricati:</span
                            >
                            <ul>
                              <li
                                v-for="(file, index) in log.file_scaricati ||
                                []"
                                :key="`${log.id}-${file}-${index}`"
                              >
                                <button
                                  v-if="hasArchivedFileAt(log, index)"
                                  :class="[
                                    'archived-file-link',
                                    { disabled: !canDownloadArchivedFiles() },
                                  ]"
                                  @click="downloadArchivedFile(log, index)"
                                >
                                  {{ getArchivedFileLabel(log, index) }}
                                </button>
                                <template v-else>{{ file }}</template>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <p v-if="archivedFilesMessage" class="archived-files-message">
                    {{ archivedFilesMessage }}
                  </p>
                </div>
              </div>
            </transition>

            <!-- Modal di conferma -->
            <div v-if="modalVisibile" class="modal-overlay">
              <div
                class="modal-content"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modalTitle"
                aria-describedby="modalDesc"
              >
                <h3 id="modalTitle">{{ modalTitolo }}</h3>
                <p id="modalDesc">{{ modalMessaggio }}</p>
                <button @click="confermaAzione" class="btn btn-confirm">
                  Conferma
                </button>
                <button @click="annullaAzione" class="btn btn-cancel">
                  Annulla
                </button>
              </div>
            </div>

            <div v-if="convertTestModalVisibile" class="modal-overlay">
              <div
                class="modal-content convert-test-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="convertTestTitle"
              >
                <h3 id="convertTestTitle">Rendi utente test</h3>
                <p>
                  Imposta una nuova password MyStudio per
                  <strong>{{ convertTestUtente?.email }}</strong
                  >. L'account verrà scollegato dall'autenticazione esterna e
                  potrà accedere come utente test dello studio.
                </p>
                <input
                  v-model="convertTestPassword"
                  type="password"
                  placeholder="Nuova password test"
                  autocomplete="new-password"
                />
                <input
                  v-model="convertTestConfirmPassword"
                  type="password"
                  placeholder="Conferma password test"
                  autocomplete="new-password"
                />
                <p v-if="convertTestError" class="convert-test-error">
                  {{ convertTestError }}
                </p>
                <div class="modal-button-row">
                  <button
                    @click="convertiUtenteInTest"
                    class="btn btn-confirm"
                    :disabled="convertTestLoading"
                  >
                    {{ convertTestLoading ? "Conversione..." : "Conferma" }}
                  </button>
                  <button
                    @click="chiudiConversioneUtenteTest"
                    class="btn btn-cancel"
                    :disabled="convertTestLoading"
                  >
                    Annulla
                  </button>
                </div>
              </div>
            </div>

            <div v-if="resetTestModalVisibile" class="modal-overlay">
              <div
                class="modal-content convert-test-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="resetTestTitle"
              >
                <h3 id="resetTestTitle">Reset password test</h3>
                <p>
                  Imposta una nuova password MyStudio per
                  <strong>{{ resetTestUtente?.email }}</strong
                  >. L'utente accederà come utente test dello studio.
                </p>
                <input
                  v-model="resetTestPassword"
                  type="password"
                  placeholder="Nuova password"
                  autocomplete="new-password"
                />
                <input
                  v-model="resetTestConfirmPassword"
                  type="password"
                  placeholder="Conferma password"
                  autocomplete="new-password"
                />
                <p v-if="resetTestError" class="convert-test-error">
                  {{ resetTestError }}
                </p>
                <div class="modal-button-row">
                  <button
                    @click="resetPasswordUtenteTest"
                    class="btn btn-confirm"
                    :disabled="resetTestLoading"
                  >
                    {{ resetTestLoading ? "Salvataggio..." : "Conferma" }}
                  </button>
                  <button
                    @click="chiudiResetPasswordTest"
                    class="btn btn-cancel"
                    :disabled="resetTestLoading"
                  >
                    Annulla
                  </button>
                </div>
              </div>
            </div>

            <div
              v-if="dettagliUtenteModalVisibile"
              class="modal-overlay"
              @click.self="chiudiDettagliUtente"
            >
              <div
                class="modal-content user-details-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="userDetailsTitle"
              >
                <h3 id="userDetailsTitle">Dettagli utente</h3>
                <div class="user-details-grid">
                  <span>Nome</span>
                  <strong>{{ dettagliUtente?.first_name || "—" }}</strong>
                  <span>Cognome</span>
                  <strong>{{ dettagliUtente?.last_name || "—" }}</strong>
                  <span>Email</span>
                  <strong>{{ dettagliUtente?.email || "—" }}</strong>
                  <span>Acquisti in App</span>
                  <strong>{{
                    dettagliUtente?.puo_fare_acquisti ? "Sì" : "No"
                  }}</strong>
                  <span>Modifica impostazioni App</span>
                  <strong>
                    {{
                      effectiveCanManageStudioSettings(dettagliUtente)
                        ? "Sì"
                        : "No"
                    }}
                  </strong>
                  <span>Stato</span>
                  <strong>{{
                    userInvitationStatusLabel(dettagliUtente || {})
                  }}</strong>
                  <span>Data di registrazione</span>
                  <strong>{{
                    formatDate(dettagliUtente?.data_registrazione)
                  }}</strong>
                  <span>Conversioni Prospetti Paghe</span>
                  <strong>{{
                    dettagliUtente?.conversioni_effettuate_prospetti || 0
                  }}</strong>
                  <span>Conversioni Modelli F24</span>
                  <strong>{{
                    dettagliUtente?.conversioni_effettuate_f24 || 0
                  }}</strong>
                  <span>Conversioni Bilanci Analitici</span>
                  <strong>{{
                    dettagliUtente?.conversioni_effettuate_bilanci || 0
                  }}</strong>
                </div>
                <div class="modal-button-row">
                  <button @click="chiudiDettagliUtente" class="btn btn-confirm">
                    Chiudi
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="isAdminOrMyStudioAdmin && activeAdminPanel === 'files'"
            class="studio-files-section"
          >
            <FileExplorer
              scope="studio"
              embedded
              split-view
              user-navigation
              title="Librerie dello studio"
              title-icon="fa-solid fa-folder-tree"
              description="Sono riportate le Librerie Codici Conto e Codici Tributo utilizzate negli account di ogni membro del tuo studio."
              :root-label="studioFileRootLabel"
              :labels="studioFileDisplayLabels"
              :include-paths="studioFileVisiblePaths"
              :tree-transformer="buildStudioAccountingTreeView"
              start-path="utenti"
              show-start-path-node
              :default-open-depth="1"
              :allow-folder-delete="false"
              permission-error-message="Non hai i permessi per visualizzare i file degli utenti."
            />
          </div>
        </div>
      </div>
    </section>
    <SuccessMessage
      :message="successModalMessaggio"
      :isVisible="successModalVisibile"
      @close="onSuccessModalClosed"
    />
    <div v-if="lastInvitationLink" class="invite-link-panel">
      <div>
        <strong>Link invito generato</strong>
        <p>
          Se l'email automatica non e configurata, copia questo link e invialo
          all'utente.
        </p>
        <code>{{ lastInvitationLink }}</code>
      </div>
      <button type="button" @click="copyInvitationLink(lastInvitationLink)">
        Copia link
      </button>
    </div>
    <SalvaModifiche
      :isVisible="showSaveModal"
      :message="'Hai modifiche non salvate. Vuoi salvarle prima di uscire?'"
      @save="handleSaveBeforeLeave"
      @close="cancelLeave"
      @discard="discardChangesAndLeave"
    />
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/config.js";
import { haFunzionalita as ha } from "@/utils/plans";
import SuccessMessage from "../components/SuccessMessage.vue";
import SalvaModifiche from "../components/SalvaModifiche.vue";
import FileExplorer from "@/components/FileExplorer.vue";
import AnagraficaClienti from "@/views/AnagraficaClienti.vue";
import ArchivioFileConvertiti from "@/views/ArchivioFileConvertiti.vue";
import ProductIcon from "@/components/ProductIcon.vue";
import { floatingTablePanelStyle } from "@/utils/floatingTablePanel";
import { withVisibleConvertedFiles } from "@/utils/downloadLogs";

export default {
  name: "AreaGestionale",
  components: {
    SuccessMessage,
    SalvaModifiche,
    FileExplorer,
    AnagraficaClienti,
    ArchivioFileConvertiti,
    ProductIcon,
  },
  data() {
    return {
      studio: null, // Solo uno studio
      currentPlan: null,
      dataInizio: null,
      dataScadenza: null,
      isLoading: false,
      utenti: [], // Utenti solo di questo studio
      userSearchQuery: "",
      userRoleFilter: "all",
      tipoRegistrazione: "esistente",
      modalUtentiVisibile: false,
      storicoOperazioni: [],
      isLoadingStorico: false,
      loadingRegistrazione: false,
      storicoModalVisibile: false,
      storicoModalUtenteEmail: "",
      expandedRows: [],
      newUser: {
        firstName: "",
        lastName: "",
        email: "",
        accountType: "real",
        password: "",
        confirmPassword: "",
        crediti_disponibili: null,
        studio_name: "",
      },
      mostraFormRegistrazione: false,
      erroreRegistrazione: "",
      confermaRegistrazione: false,
      showPassword: false,
      showKeyModal: false,
      showStudioUsersModal: false,
      savingStudioAccount: false,
      studioAccountError: "",
      studioAccount: {
        partita_iva: "",
        indirizzo_sede: "",
        cap: "",
        citta: "",
        provincia: "",
      },
      copySuccess: "",
      copyFeedbackLocation: "",
      isEditing: false,
      newRegistrationKey: "",
      errorMessage: "",
      successMessage: "",
      isLoadingKey: false,
      modalVisibile: false,
      modalTitolo: "",
      modalMessaggio: "",
      azioneDaConfermare: null,
      utenteSelezionato: null,
      convertTestModalVisibile: false,
      convertTestUtente: null,
      convertTestPassword: "",
      convertTestConfirmPassword: "",
      convertTestError: "",
      convertTestLoading: false,
      resetTestModalVisibile: false,
      resetTestUtente: null,
      resetTestPassword: "",
      resetTestConfirmPassword: "",
      resetTestError: "",
      resetTestLoading: false,
      dettagliUtenteModalVisibile: false,
      dettagliUtente: null,
      activeUserActionsMenu: null,
      userActionsMenuStyle: {},
      activeConversionDetails: null,
      conversionPopoverStyle: {},
      successModalVisibile: false,
      successModalMessaggio: "",
      lastInvitationLink: "",
      showSaveModal: false,
      nextRoute: null,
      waitingForSuccessConfirm: false,
      archivedFilesMessage: "",
      archivedFilesMessageTimeout: null,
      studioFileLabels: {
        clienti: "Libreria Clienti Bilancio Analitico",
        utenti: "Nome dello studio",
        PianiContabili: "Librerie dello studio",
        "Piani dei Clienti": "Librerie Personalizzate per clienti",
      },
      studioFileVisiblePaths: ["utenti"],
    };
  },
  computed: {
    activeAdminPanel() {
      const tab = this.$route.query.tab || "studio";
      const allowed = ["studio", "clienti", "archivio"];
      if (this.isAdminOrMyStudioAdmin)
        allowed.push("utenti", "files", "account");
      return allowed.includes(tab) ? tab : "studio";
    },
    activePanelMeta() {
      const panels = {
        studio: {
          title: "Panoramica",
          subtitle:
            "Una vista completa dello stato del tuo studio, delle conversioni e del piano attivo.",
          icon: "fa-solid fa-house",
        },
        clienti: {
          title: "Anagrafica Clienti",
          subtitle:
            "Gestisci i clienti dello studio e i relativi dati identificativi.",
          icon: "fa-solid fa-address-book",
        },
        archivio: {
          title: "Archivio file convertiti",
          subtitle:
            "Consulta e scarica i documenti convertiti dagli utenti dello studio.",
          icon: "fa-solid fa-box-archive",
        },
        utenti: {
          title: "Utenze",
          subtitle:
            "Gestisci gli utenti, i ruoli e le autorizzazioni del tuo studio.",
          icon: "fa-solid fa-users",
        },
        files: {
          title: "Librerie dello studio",
          subtitle:
            "Esplora le librerie contabili condivise dagli utenti dello studio.",
          icon: "fa-solid fa-folder-tree",
        },
        account: {
          title: "Account Studio",
          subtitle:
            "Gestisci i dati fiscali e le informazioni della sede dello studio.",
          icon: "fa-solid fa-gear",
        },
      };

      return panels[this.activeAdminPanel] || panels.studio;
    },
    user() {
      const data = localStorage.getItem("user");
      return data ? JSON.parse(data) : null;
    },
    isAdminOrMyStudioAdmin() {
      return this.$route.meta.studioAdmin === true;
    },
    userEmail() {
      return localStorage.getItem("userEmail") || "";
    },
    hasUnsavedChanges() {
      return this.utenti.some((utente) => this.hasChanges(utente));
    },
    hasUnsavedStudioAccountChanges() {
      if (!this.studio) return false;

      return [
        "partita_iva",
        "indirizzo_sede",
        "cap",
        "citta",
        "provincia",
      ].some((field) => {
        const draftValue = String(this.studioAccount[field] || "").trim();
        const savedValue = String(this.studio[field] || "").trim();
        return field === "provincia"
          ? draftValue.toUpperCase() !== savedValue.toUpperCase()
          : draftValue !== savedValue;
      });
    },
    filteredUtenti() {
      const query = this.userSearchQuery.trim().toLocaleLowerCase("it");

      return this.utenti.filter((utente) => {
        const searchableText = `${this.userFullName(utente)} ${
          utente.email || ""
        }`.toLocaleLowerCase("it");
        const matchesQuery = !query || searchableText.includes(query);
        const matchesRole =
          this.userRoleFilter === "all" ||
          (this.userRoleFilter === "admin"
            ? this.isAdminRole(utente.ruolo)
            : utente.ruolo === this.userRoleFilter);

        return matchesQuery && matchesRole;
      });
    },
    currentPlanLabel() {
      if (this.currentPlan === "base") return "Base";
      if (this.currentPlan === "plus") return "Plus";
      if (this.currentPlan === "premium") return "Premium";
      return "—";
    },
    studioUsers() {
      return [...(this.studio?.utenti || [])].sort((a, b) =>
        a.localeCompare(b, "it", { sensitivity: "base" })
      );
    },
    studioUserProfiles() {
      const detailedUsers = new Map(
        this.utenti.map((utente) => [
          String(utente?.email || "").toLocaleLowerCase("it"),
          utente,
        ])
      );

      const profiles = this.studioUsers.map((email) => {
        const normalizedEmail = String(email || "").toLocaleLowerCase("it");
        return (
          detailedUsers.get(normalizedEmail) || {
            email,
            first_name: "",
            last_name: "",
          }
        );
      });

      const listedEmails = new Set(
        profiles.map((utente) =>
          String(utente?.email || "").toLocaleLowerCase("it")
        )
      );
      this.utenti.forEach((utente) => {
        const normalizedEmail = String(utente?.email || "").toLocaleLowerCase(
          "it"
        );
        if (normalizedEmail && !listedEmails.has(normalizedEmail)) {
          profiles.push(utente);
          listedEmails.add(normalizedEmail);
        }
      });

      return profiles;
    },
    registeredUsersCount() {
      return this.studio?.utenti_count ?? this.studioUsers.length;
    },
    studioConvertedDocumentsTotal() {
      return (
        Number(this.studio?.conversioni_effettuate_prospetti || 0) +
        Number(this.studio?.conversioni_effettuate_f24 || 0) +
        Number(this.studio?.conversioni_effettuate_bilanci || 0)
      );
    },
    isValidKey() {
      return (
        this.newRegistrationKey &&
        /^[a-zA-Z0-9]{5,36}$/.test(this.newRegistrationKey)
      );
    },
    studioFileRootLabel() {
      return this.studio?.nome || "Librerie dello studio";
    },
    studioFileDisplayLabels() {
      return {
        ...this.studioFileLabels,
        utenti: this.studio?.nome || "Nome dello studio",
      };
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.hasUnsavedChanges ||
      this.hasUnsavedClientChanges() ||
      this.hasUnsavedStudioAccountChanges
    ) {
      this.showSaveModal = true;
      this.nextRoute = next; // memorizza la funzione per usarla dopo
    } else {
      next();
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (
      this.hasUnsavedChanges ||
      this.hasUnsavedClientChanges() ||
      this.hasUnsavedStudioAccountChanges
    ) {
      this.showSaveModal = true;
      this.nextRoute = next;
    } else {
      next();
    }
  },
  methods: {
    ha,
    hasUnsavedClientChanges() {
      return Boolean(this.$refs.clientiPanel?.hasUnsavedChanges);
    },
    selectPanel(tab) {
      this.$router.push({ name: "AreaGestionale", query: { tab } });
    },
    buildStudioAccountingTreeView(nodes) {
      return (nodes || []).map((node) =>
        this.transformAccountingTreeNode(node)
      );
    },
    transformAccountingTreeNode(node) {
      if (!node || node.type !== "folder") return node;

      const children = (node.children || []).flatMap((child) => {
        const transformedChild = this.transformAccountingTreeNode(child);
        return this.isAccountingPlansNode(transformedChild)
          ? this.buildAccountingLibraryNodes(transformedChild)
          : [transformedChild];
      });

      return {
        ...node,
        children,
      };
    },
    isAccountingPlansNode(node) {
      return node?.type === "folder" && node.name === "PianiContabili";
    },
    buildAccountingLibraryNodes(node) {
      const children = Array.isArray(node.children) ? node.children : [];
      const personalizedNode = children.find(
        (child) => child.type === "folder" && child.name === "Piani dei Clienti"
      );
      const generalItems = children.filter(
        (child) => child !== personalizedNode
      );
      const groupDefinitions = [
        {
          key: "prospetti-paghe",
          label: "Libreria Codici Conto",
          sortOrder: 10,
        },
        {
          key: "modelli-f24",
          label: "Libreria Codici Tributo",
          sortOrder: 20,
        },
      ];

      return groupDefinitions.map((group) => {
        const mainPlans = generalItems.filter(
          (item) => this.resolveAccountingToolGroup(item) === group.key
        );
        const mainFiles = this.buildMainFilesNode({
          items: mainPlans,
          parentPath: node.rel_path,
          groupKey: group.key,
        });
        const personalizedFiles = this.buildPersonalizedFilesNode({
          sourceNode: personalizedNode,
          parentPath: node.rel_path,
          groupKey: group.key,
        });

        return {
          name: group.label,
          display_name: group.label,
          rel_path: `${node.rel_path}/__${group.key}`,
          type: "folder",
          sort_order: group.sortOrder,
          children: [mainFiles, personalizedFiles],
        };
      });
    },
    buildMainFilesNode({ items, parentPath, groupKey }) {
      return {
        name: "File principali",
        display_name: "File principali",
        rel_path: `${parentPath}/__${groupKey}-principali`,
        type: "folder",
        sort_order: 10,
        children: items,
      };
    },
    buildPersonalizedFilesNode({ sourceNode, parentPath, groupKey }) {
      const clients = (sourceNode?.children || [])
        .filter((clientNode) => clientNode?.type === "folder")
        .map((clientNode) => ({
          ...clientNode,
          rel_path: `${parentPath}/__${groupKey}-personalizzati/${clientNode.name}`,
          children: (clientNode.children || []).filter(
            (item) => this.resolveAccountingToolGroup(item) === groupKey
          ),
        }))
        .filter((clientNode) => clientNode.children.length);

      return {
        name: "File personalizzati per clienti",
        display_name: "File personalizzati per clienti",
        rel_path: `${parentPath}/__${groupKey}-personalizzati`,
        type: "folder",
        sort_order: 20,
        children: clients,
      };
    },
    resolveAccountingToolGroup(item) {
      const name = String(item?.display_name || item?.name || "").toLowerCase();
      if (
        name.includes("prospetti paghe") ||
        name.includes("codici conto") ||
        name.includes("cod. conto") ||
        name.includes("piano dei conti")
      ) {
        return "prospetti-paghe";
      }
      if (name.includes("modelli f24") || name.includes("tributo")) {
        return "modelli-f24";
      }
      return "altri";
    },
    async handleSaveBeforeLeave() {
      if (this.hasUnsavedClientChanges()) {
        await this.$refs.clientiPanel.saveChanges();
        if (this.$refs.clientiPanel.hasUnsavedChanges) return;
        this.showSaveModal = false;
        const next = this.nextRoute;
        this.nextRoute = null;
        if (next) next();
        return;
      }
      if (this.hasUnsavedStudioAccountChanges) {
        const saved = await this.saveStudioAccount();
        if (!saved) return;
        this.showSaveModal = false;
        const next = this.nextRoute;
        this.nextRoute = null;
        if (next) next();
        return;
      }
      this.salvaTutteModifiche()
        .then(() => {
          this.showSaveModal = false;
        })
        .catch((err) => {
          console.error("Errore durante il salvataggio:", err);
          // qui puoi decidere se lasciare il modal aperto o chiuderlo
        });
    },

    cancelLeave() {
      this.showSaveModal = false;
      if (this.nextRoute) this.nextRoute(false);
      this.nextRoute = null;
    },

    discardChangesAndLeave() {
      if (this.hasUnsavedClientChanges()) {
        this.$refs.clientiPanel.cancelChanges();
      } else if (this.hasUnsavedStudioAccountChanges) {
        this.resetStudioAccount();
      } else {
        this.annullaModifiche();
      }
      this.showSaveModal = false;
      if (this.nextRoute) {
        this.nextRoute();
        this.nextRoute = null;
      }
    },

    salvaTutteModifiche() {
      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";

      const promises = this.utenti
        .filter((u) => this.hasChanges(u))
        .map((u) => this.aggiornaRuoloUtentePromise(u));

      return Promise.all(promises)
        .then(() => {
          this.successModalMessaggio =
            "Tutte le modifiche sono state salvate con successo!";
          this.successModalVisibile = true;
          this.waitingForSuccessConfirm = true;

          // Aggiorna i valori originali dopo il salvataggio
          this.utenti.forEach((u) => {
            u.ruolo_originale = u.ruolo;
            u.puo_fare_acquisti_originale = u.puo_fare_acquisti;
            u.can_manage_studio_settings_originale =
              u.can_manage_studio_settings;
          });
        })
        .catch((err) => {
          console.error("Errore durante il salvataggio:", err);
          alert("Errore durante il salvataggio delle modifiche.");
        })
        .finally(() => {
          document.documentElement.style.cursor = "default";
          document.body.style.cursor = "default";
        });
    },

    annullaModifiche() {
      this.utenti.forEach((u) => {
        u.ruolo = u.ruolo_originale;
        u.puo_fare_acquisti = u.puo_fare_acquisti_originale;
        u.can_manage_studio_settings = u.can_manage_studio_settings_originale;
      });
    },
    isAdminRole(role) {
      return ["admin", "adminMyStudio"].includes(role);
    },
    effectiveCanManageStudioSettings(utente) {
      return (
        this.isAdminRole(utente.ruolo) ||
        Boolean(utente.can_manage_studio_settings)
      );
    },
    originalEffectiveCanManageStudioSettings(utente) {
      return (
        this.isAdminRole(utente.ruolo_originale) ||
        Boolean(utente.can_manage_studio_settings_originale)
      );
    },
    setCanManageStudioSettings(utente, value) {
      if (this.isAdminRole(utente.ruolo)) {
        utente.can_manage_studio_settings = true;
        return;
      }
      utente.can_manage_studio_settings = Boolean(value);
    },
    handleUserRoleChange(utente) {
      if (this.isAdminRole(utente.ruolo)) {
        utente.puo_fare_acquisti = true;
        utente.can_manage_studio_settings = true;
      } else if (this.isAdminRole(utente.ruolo_originale)) {
        utente.puo_fare_acquisti = false;
        utente.can_manage_studio_settings = false;
      } else if (utente.ruolo === utente.ruolo_originale) {
        utente.puo_fare_acquisti = utente.puo_fare_acquisti_originale;
        utente.can_manage_studio_settings =
          utente.can_manage_studio_settings_originale;
      }
    },

    aggiornaRuoloUtentePromise(utente) {
      return axios
        .post(`${API_BASE_URL}/admin/update_utente`, {
          email: utente.email,
          ruolo: utente.ruolo,
          puo_fare_acquisti: utente.puo_fare_acquisti,
          can_manage_studio_settings: utente.can_manage_studio_settings,
        })
        .then((response) => {
          if (response.data) {
            utente.ruolo = response.data.nuovo_ruolo || utente.ruolo;
            utente.can_manage_studio_settings = Boolean(
              response.data.can_manage_studio_settings
            );
          }
          utente.ruolo_originale = utente.ruolo;
          utente.puo_fare_acquisti_originale = utente.puo_fare_acquisti;
          utente.can_manage_studio_settings_originale =
            utente.can_manage_studio_settings;
        });
    },

    onSuccessModalClosed() {
      this.successModalVisibile = false;

      if (this.waitingForSuccessConfirm && this.nextRoute) {
        this.nextRoute();
        this.nextRoute = null;
        this.waitingForSuccessConfirm = false;
      }
    },

    totaleConversioniUtente(utente) {
      return (
        Number(utente.conversioni_effettuate_prospetti || 0) +
        Number(utente.conversioni_effettuate_f24 || 0) +
        Number(utente.conversioni_effettuate_bilanci || 0)
      );
    },

    formatDate(isoString) {
      if (!isoString) return "-----";
      const date = new Date(isoString);
      return date.toLocaleDateString("it-IT", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    copyRegistrationKey(location) {
      const key = this.studio.registration_key;
      this.copyFeedbackLocation = location;
      navigator.clipboard
        .writeText(key)
        .then(() => {
          this.copySuccess = "Copiato!";
          setTimeout(() => {
            this.copySuccess = "";
            this.copyFeedbackLocation = "";
          }, 2000);
        })
        .catch(() => {
          this.copySuccess = "Errore!";
          setTimeout(() => {
            this.copySuccess = "";
            this.copyFeedbackLocation = "";
          }, 2000);
        });
    },

    openStudioAccountPanel() {
      if (this.activeAdminPanel === "account") return;
      this.resetStudioAccount();
      this.selectPanel("account");
    },

    resetStudioAccount() {
      this.studioAccountError = "";
      this.studioAccount = {
        partita_iva: this.studio?.partita_iva || "",
        indirizzo_sede: this.studio?.indirizzo_sede || "",
        cap: this.studio?.cap || "",
        citta: this.studio?.citta || "",
        provincia: this.studio?.provincia || "",
      };
    },

    async saveStudioAccount() {
      this.savingStudioAccount = true;
      this.studioAccountError = "";
      try {
        const payload = {
          ...this.studioAccount,
          partita_iva: this.studioAccount.partita_iva.trim(),
          indirizzo_sede: this.studioAccount.indirizzo_sede.trim(),
          cap: this.studioAccount.cap.trim(),
          citta: this.studioAccount.citta.trim(),
          provincia: this.studioAccount.provincia.trim().toUpperCase(),
        };
        const response = await axios.put(
          `${API_BASE_URL}/studio/account`,
          payload
        );
        this.studio = { ...this.studio, ...response.data.studio };
        this.resetStudioAccount();
        this.successModalMessaggio =
          "Dati dello studio aggiornati con successo.";
        this.successModalVisibile = true;
        return true;
      } catch (error) {
        this.studioAccountError =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Errore durante il salvataggio dei dati dello studio.";
        return false;
      } finally {
        this.savingStudioAccount = false;
      }
    },

    startEditing() {
      this.isEditing = true;
      this.newRegistrationKey = "";
      this.clearMessages();
    },

    clearMessages() {
      this.errorMessage = "";
      this.successMessage = "";
    },

    closeModal() {
      this.showKeyModal = false;
      this.isEditing = false;
      this.newRegistrationKey = "";
      this.clearMessages();
    },

    async saveNewKey() {
      this.clearMessages();
      this.isLoadingKey = true;

      try {
        const response = await axios.put(
          `${API_BASE_URL}/studi/update_registration_key`,
          { new_registration_key: this.newRegistrationKey }
        );

        if (response.data.success) {
          this.successMessage = response.data.message;
          this.studio.registration_key = response.data.new_key; // Aggiorna la chiave localmente
          setTimeout(() => {
            this.closeModal();
          }, 2000);
        } else {
          this.errorMessage =
            response.data.message || "Errore durante l'aggiornamento.";
        }
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message || "Errore di connessione al server.";
      } finally {
        this.isLoadingKey = false;
      }
    },

    async scaricaExcelUtenti() {
      const datiExcel = this.utenti.map((utente) => ({
        Email: utente.email,
        "Ruolo utente": utente.ruolo,
        "Data di Registrazione": this.formatDate(utente.data_registrazione),
        "Conversioni effettuate": this.totaleConversioniUtente(utente),
      }));

      try {
        const response = await axios.post(
          `${API_BASE_URL}/genera_excel_utenti`,
          { dati: datiExcel, nomeStudio: this.studio?.nome || "Sconosciuto" },
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = `Utenti ${this.studio.nome} - MyStudio.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Errore nel download del file", error);
        alert("Errore nel download del file");
      }
    },

    async fetchDataCompleta() {
      this.isLoading = true;
      try {
        // 1. Carichiamo prima lo studio (serve l'ID per gli utenti)
        const studioResponse = await axios.get(
          `${API_BASE_URL}/studio/overview`
        );
        this.studio = studioResponse.data.studio;
        this.resetStudioAccount();

        if (!this.studio || !this.studio.id) {
          console.error("Studio non trovato o senza ID");
          this.utenti = [];
          this.currentPlan = null;
          this.dataInizio = null;
          this.dataScadenza = null;
          return;
        }

        // 2. Carichiamo l'abbonamento (in parallelo allo studio va bene, ma lo facciamo dopo per chiarezza)
        const abbonamentoResponse = await axios.get(
          `${API_BASE_URL}/abbonamento`
        );

        // Salviamo tutte le info utili dell'abbonamento
        this.currentPlan = abbonamentoResponse.data.current_plan || null;
        this.dataInizio = abbonamentoResponse.data.data_inizio || null;
        this.dataScadenza =
          abbonamentoResponse.data.data_scadenza ||
          abbonamentoResponse.data.data_fine ||
          null;

        // 3. Ora che abbiamo l'ID dello studio, carichiamo gli utenti
        if (this.isAdminOrMyStudioAdmin) {
          const utentiResponse = await axios.get(
            `${API_BASE_URL}/admin/get_users_by_studio/${this.studio.id}`,
            { params: { t: Date.now() } }
          );
          this.utenti = (utentiResponse.data.users || []).map((u) => ({
            ...u,
            ruolo_originale: u.ruolo,
            puo_fare_acquisti: Boolean(u.puo_fare_acquisti),
            puo_fare_acquisti_originale: Boolean(u.puo_fare_acquisti),
            can_manage_studio_settings: Boolean(u.can_manage_studio_settings),
            can_manage_studio_settings_originale: Boolean(
              u.can_manage_studio_settings
            ),
          }));
        }
      } catch (error) {
        console.error("Errore nel caricamento dei dati admin:", error);

        // Reset completo in caso di errore
        this.studio = null;
        this.utenti = [];
        this.currentPlan = null;
        this.dataInizio = null;
        this.dataScadenza = null;
      } finally {
        this.isLoading = false;
      }
    },

    async apriStoricoOperazioni(emailUtente) {
      this.isLoadingStorico = true;
      this.storicoModalUtenteEmail = emailUtente;
      this.storicoModalVisibile = true;

      try {
        const response = await axios.get(
          `${API_BASE_URL}/admin/download_logs_user`,
          {
            params: { email: emailUtente },
          }
        );

        if (response.data.success) {
          this.storicoOperazioni = (response.data.logs || []).map(
            withVisibleConvertedFiles
          );
        } else {
          this.storicoOperazioni = [];
          console.warn(
            "Nessuna operazione trovata o errore:",
            response.data.error
          );
        }
      } catch (error) {
        console.error("Errore nel recupero dello storico operazioni:", error);
        this.storicoOperazioni = [];
      } finally {
        this.isLoadingStorico = false;
      }
    },
    hasChanges(utente) {
      return (
        utente.ruolo !== utente.ruolo_originale ||
        utente.puo_fare_acquisti !== utente.puo_fare_acquisti_originale ||
        this.effectiveCanManageStudioSettings(utente) !==
          this.originalEffectiveCanManageStudioSettings(utente)
      );
    },
    chiudiStoricoModal() {
      this.storicoModalVisibile = false;
      this.storicoOperazioni = [];
      this.storicoModalUtenteEmail = "";
    },

    toggleExpand(id) {
      const index = this.expandedRows.indexOf(id);
      if (index === -1) {
        this.expandedRows.push(id);
      } else {
        this.expandedRows.splice(index, 1);
      }
    },

    isExpanded(id) {
      return this.expandedRows.includes(id);
    },
    hasArchivedFiles(log) {
      return (
        Array.isArray(log?.archived_files) && log.archived_files.length > 0
      );
    },
    hasUploadedArchivedFile(log) {
      return !!log?.uploaded_archived_files?.[0]?.relative_path;
    },
    hasArchivedFileAt(log, index) {
      return !!log?.archived_files?.[index]?.relative_path;
    },
    canDownloadArchivedFiles() {
      return ha(this.user, "archivio_scaricabile_file_convertiti");
    },
    getArchivedFileLabel(log, index) {
      return (
        log?.archived_files?.[index]?.display_name ||
        log?.file_scaricati?.[index] ||
        "Scarica file"
      );
    },
    getUploadedArchivedFileLabel(log) {
      return log?.uploaded_archived_files?.[0]?.display_name || log?.file_name;
    },
    showArchivedFilesMessage(message) {
      this.archivedFilesMessage =
        message || "Per scaricare i file archiviati serve il piano Premium.";
      clearTimeout(this.archivedFilesMessageTimeout);
      this.archivedFilesMessageTimeout = setTimeout(() => {
        this.archivedFilesMessage = "";
      }, 3000);
    },
    isInlinePreviewable(fileName) {
      const ext = (fileName || "").split(".").pop()?.toLowerCase() || "";
      return [
        "pdf",
        "csv",
        "txt",
        "png",
        "jpg",
        "jpeg",
        "gif",
        "webp",
      ].includes(ext);
    },
    buildArchivedFileUrl(logId, fileIndex, archiveKind, disposition) {
      const params = new URLSearchParams({
        log_id: String(logId),
        file_index: String(fileIndex),
        archive_kind: archiveKind,
        disposition,
      });
      return `${API_BASE_URL}/download_archived_log_file?${params.toString()}`;
    },
    async openOrDownloadArchivedFile({
      log,
      fileIndex,
      archiveKind,
      fileName,
      errorMessage,
    }) {
      if (!this.canDownloadArchivedFiles()) {
        this.showArchivedFilesMessage();
        return;
      }

      const disposition = this.isInlinePreviewable(fileName)
        ? "inline"
        : "attachment";
      const url = this.buildArchivedFileUrl(
        log.id,
        fileIndex,
        archiveKind,
        disposition
      );

      try {
        if (disposition === "inline") {
          window.open(url, "_blank", "noopener");
          return;
        }

        const response = await axios.get(url, { responseType: "blob" });
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error("Errore apertura/download file archiviato:", error);
        this.showArchivedFilesMessage(errorMessage);
      }
    },
    async downloadArchivedFile(log, index) {
      await this.openOrDownloadArchivedFile({
        log,
        fileIndex: index,
        archiveKind: "converted",
        fileName: this.getArchivedFileLabel(log, index),
        errorMessage:
          "Impossibile aprire o scaricare il file archiviato in questo momento.",
      });
    },
    async downloadUploadedArchivedFile(log) {
      await this.openOrDownloadArchivedFile({
        log,
        fileIndex: 0,
        archiveKind: "uploaded",
        fileName: this.getUploadedArchivedFileLabel(log),
        errorMessage:
          "Impossibile aprire o scaricare il file caricato archiviato in questo momento.",
      });
    },

    eliminaUtente(email) {
      axios
        .delete(
          `${API_BASE_URL}/admin/delete_user?email=${encodeURIComponent(email)}`
        )
        .then(() => {
          this.fetchDataCompleta(); // ricarica lista utenti
          this.successModalVisibile = true;
          this.successModalMessaggio = `Utente "${email}" eliminato con successo.`;
        })
        .catch((err) => {
          console.error("Errore eliminazione utente:", err);
          alert("Errore durante l'eliminazione dell'utente");
        });
    },

    async registraUtente() {
      this.loadingRegistrazione = true;
      this.erroreRegistrazione = "";
      this.confermaRegistrazione = false;

      // Piccolo controllo lato client (opzionale ma consigliato)
      if (!this.newUser.firstName?.trim() || !this.newUser.lastName?.trim()) {
        this.erroreRegistrazione = "Nome e Cognome sono obbligatori.";
        this.loadingRegistrazione = false;
        return;
      }

      if (!this.newUser.email?.trim()) {
        this.erroreRegistrazione = "Compila tutti i campi obbligatori.";
        this.loadingRegistrazione = false;
        return;
      }

      if (this.newUser.accountType === "test") {
        if (!this.studio?.is_test_studio) {
          this.erroreRegistrazione =
            "Gli utenti test sono consentiti solo negli studi di test.";
          this.loadingRegistrazione = false;
          return;
        }

        if (!this.newUser.password || !this.newUser.confirmPassword) {
          this.erroreRegistrazione = "Inserisci e conferma la password test.";
          this.loadingRegistrazione = false;
          return;
        }

        if (this.newUser.password !== this.newUser.confirmPassword) {
          this.erroreRegistrazione = "Le password non coincidono.";
          this.loadingRegistrazione = false;
          return;
        }
      }

      try {
        const isTestUser = this.newUser.accountType === "test";
        const response = await axios.post(
          `${API_BASE_URL}/admin/register_user`,
          {
            email: this.newUser.email.trim(),
            password: isTestUser ? this.newUser.password : undefined,
            first_name: this.newUser.firstName.trim(), // ← aggiunto
            last_name: this.newUser.lastName.trim(), // ← aggiunto
            crediti_disponibili: Number(this.newUser.crediti_disponibili) || 0,
            studio_name: this.studio.nome,
            tipoRegistrazione: "esistente",
            account_type: isTestUser ? "test" : "real",
            force_password_setup: !isTestUser,
          },
          { withCredentials: true }
        );

        if (response.data.success) {
          this.confermaRegistrazione = true;
          setTimeout(() => (this.confermaRegistrazione = false), 2000);

          this.fetchDataCompleta();

          // Reset form
          this.newUser = {
            firstName: "",
            lastName: "",
            email: "",
            accountType: "real",
            password: "",
            confirmPassword: "",
            crediti_disponibili: 0,
            studio_name: this.studio.nome || "",
          };

          this.mostraFormRegistrazione = false;
          this.lastInvitationLink = isTestUser
            ? ""
            : response.data.invitation_link || "";
          if (this.lastInvitationLink) {
            this.copyInvitationLink(this.lastInvitationLink, { silent: true });
          }
          this.successModalMessaggio =
            response.data.message ||
            (isTestUser
              ? "Utente test creato con successo."
              : "Utente creato. Invito inviato via email.");
          if (this.lastInvitationLink && !response.data.invitation_email_sent) {
            this.successModalMessaggio +=
              " Invio email non riuscito: reinvia l'invito dalla tabella utenti.";
          }
          this.successModalVisibile = true;
        }
      } catch (error) {
        console.error("Errore registrazione:", error);
        this.erroreRegistrazione =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Errore durante la registrazione";
      } finally {
        document.documentElement.style.cursor = "default";
        document.body.style.cursor = "default";
        this.loadingRegistrazione = false;
      }
    },

    userInvitationStatusLabel(utente) {
      if (utente.auth_provider === "pending_clerk") {
        return "Invito in sospeso";
      }
      if (utente.auth_provider === "internal_test") {
        return "Utente test";
      }
      if (utente.auth_provider === "clerk") {
        return "Attivo";
      }
      return "Legacy";
    },

    userInvitationStatusClass(utente) {
      if (utente.auth_provider === "pending_clerk") {
        return "pending";
      }
      if (utente.auth_provider === "internal_test") {
        return "test";
      }
      if (utente.auth_provider === "clerk") {
        return "active";
      }
      return "legacy";
    },

    userFullName(utente) {
      return (
        [utente?.first_name, utente?.last_name]
          .filter(Boolean)
          .join(" ")
          .trim() || "—"
      );
    },

    userInitials(utente) {
      const fullName = [utente?.first_name, utente?.last_name]
        .filter(Boolean)
        .join(" ")
        .trim();
      const source = fullName || utente?.email || "U";

      return source
        .split(/[\s@._-]+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part.charAt(0))
        .join("")
        .toUpperCase();
    },

    studioUserDisplayName(utente) {
      return (
        [utente?.first_name, utente?.last_name]
          .filter(Boolean)
          .join(" ")
          .trim() ||
        utente?.email ||
        "Utente"
      );
    },

    toggleConversionDetails(key, event) {
      const wasOpen = this.activeConversionDetails === key;
      this.closeTablePanels();
      if (!wasOpen) {
        this.conversionPopoverStyle = floatingTablePanelStyle(
          event.currentTarget,
          { width: 208, height: 155 }
        );
        this.activeConversionDetails = key;
      }
    },

    async toggleUserActionsMenu(utente, event) {
      const wasOpen = this.activeUserActionsMenu === utente.email;
      const trigger = event.currentTarget;
      const menuWrapper = trigger.closest(".actions-menu-wrapper");
      this.closeTablePanels();
      if (wasOpen) return;
      this.userActionsMenuStyle = {
        ...floatingTablePanelStyle(trigger, {
          width: 192,
          height: 120,
          placement: "below",
          align: "right",
        }),
        visibility: "hidden",
      };
      this.activeUserActionsMenu = utente.email;

      await this.$nextTick();
      if (this.activeUserActionsMenu !== utente.email) return;

      const dropdown = menuWrapper?.querySelector(".user-actions-dropdown");
      if (!dropdown) return;

      const dropdownRect = dropdown.getBoundingClientRect();
      this.userActionsMenuStyle = floatingTablePanelStyle(trigger, {
        width: Math.ceil(dropdownRect.width) || 192,
        height: Math.ceil(dropdownRect.height) || 120,
        placement: "below",
        align: "right",
      });
    },

    closeUserActionsMenu() {
      this.activeUserActionsMenu = null;
    },

    closeTablePanels() {
      this.closeUserActionsMenu();
      this.activeConversionDetails = null;
    },

    handleUserActionsOutsideClick(event) {
      if (
        event.target?.closest?.(".user-actions-dropdown, .conversioni-popover")
      )
        return;
      this.closeTablePanels();
    },

    apriDettagliUtente(utente) {
      this.dettagliUtente = utente;
      this.dettagliUtenteModalVisibile = true;
      this.closeUserActionsMenu();
    },

    chiudiDettagliUtente() {
      this.dettagliUtenteModalVisibile = false;
      this.dettagliUtente = null;
    },

    canResetTestUserPassword(utente) {
      return (
        this.studio?.is_test_studio === true &&
        ["internal_test", "legacy"].includes(utente.auth_provider) &&
        utente.ruolo_originale !== "adminMyStudio"
      );
    },

    canConvertUserToTest(utente) {
      return (
        this.studio?.is_test_studio === true &&
        utente.auth_provider === "clerk" &&
        utente.ruolo_originale !== "adminMyStudio"
      );
    },

    apriResetPasswordTest(utente) {
      this.resetTestUtente = utente;
      this.resetTestPassword = "";
      this.resetTestConfirmPassword = "";
      this.resetTestError = "";
      this.resetTestModalVisibile = true;
      this.closeUserActionsMenu();
    },

    chiudiResetPasswordTest() {
      if (this.resetTestLoading) return;
      this.resetTestModalVisibile = false;
      this.resetTestUtente = null;
      this.resetTestPassword = "";
      this.resetTestConfirmPassword = "";
      this.resetTestError = "";
    },

    async resetPasswordUtenteTest() {
      if (!this.resetTestUtente) return;

      if (!this.resetTestPassword || !this.resetTestConfirmPassword) {
        this.resetTestError = "Inserisci e conferma la nuova password.";
        return;
      }

      if (this.resetTestPassword.length < 8) {
        this.resetTestError = "La password deve avere almeno 8 caratteri.";
        return;
      }

      if (this.resetTestPassword !== this.resetTestConfirmPassword) {
        this.resetTestError = "Le password non coincidono.";
        return;
      }

      this.resetTestLoading = true;
      this.resetTestError = "";

      try {
        await axios.post(
          `${API_BASE_URL}/admin/reset_test_user_password`,
          {
            email: this.resetTestUtente.email,
            password: this.resetTestPassword,
          },
          { withCredentials: true }
        );

        this.successModalMessaggio = `Password aggiornata per "${this.resetTestUtente.email}".`;
        this.successModalVisibile = true;
        this.resetTestLoading = false;
        this.chiudiResetPasswordTest();
        await this.fetchDataCompleta();
      } catch (error) {
        this.resetTestError =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Errore durante il reset password.";
      } finally {
        this.resetTestLoading = false;
      }
    },

    mostraInfoResetClerk(utente) {
      this.closeUserActionsMenu();
      this.successModalMessaggio = `Per ${utente.email}, usa il link "Password dimenticata?" nella pagina di login: l'utente riceverà il codice di reset via email.`;
      this.successModalVisibile = true;
    },

    apriConversioneUtenteTest(utente) {
      this.convertTestUtente = utente;
      this.convertTestPassword = "";
      this.convertTestConfirmPassword = "";
      this.convertTestError = "";
      this.convertTestModalVisibile = true;
      this.closeUserActionsMenu();
    },

    chiudiConversioneUtenteTest() {
      if (this.convertTestLoading) return;
      this.convertTestModalVisibile = false;
      this.convertTestUtente = null;
      this.convertTestPassword = "";
      this.convertTestConfirmPassword = "";
      this.convertTestError = "";
    },

    async convertiUtenteInTest() {
      if (!this.convertTestUtente) return;

      if (!this.convertTestPassword || !this.convertTestConfirmPassword) {
        this.convertTestError = "Inserisci e conferma la nuova password test.";
        return;
      }

      if (this.convertTestPassword.length < 8) {
        this.convertTestError =
          "La password test deve avere almeno 8 caratteri.";
        return;
      }

      if (this.convertTestPassword !== this.convertTestConfirmPassword) {
        this.convertTestError = "Le password non coincidono.";
        return;
      }

      this.convertTestLoading = true;
      this.convertTestError = "";

      try {
        await axios.post(
          `${API_BASE_URL}/admin/convert_user_to_test`,
          {
            email: this.convertTestUtente.email,
            password: this.convertTestPassword,
          },
          { withCredentials: true }
        );

        this.successModalMessaggio = `Utente "${this.convertTestUtente.email}" convertito in utente test.`;
        this.successModalVisibile = true;
        this.convertTestLoading = false;
        this.chiudiConversioneUtenteTest();
        await this.fetchDataCompleta();
      } catch (error) {
        this.convertTestError =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Errore durante la conversione in utente test.";
      } finally {
        this.convertTestLoading = false;
      }
    },

    async copyInvitationLink(link, options = {}) {
      if (!link) return;

      try {
        await navigator.clipboard.writeText(link);
        if (!options.silent) {
          this.successModalMessaggio = "Link invito copiato negli appunti.";
          this.successModalVisibile = true;
        }
      } catch (error) {
        console.warn("Copia link invito non riuscita", error);
      }
    },

    async reinviaInvitoUtente(utente) {
      this.closeUserActionsMenu();
      try {
        const response = await axios.post(
          `${API_BASE_URL}/admin/resend_user_invite`,
          { email: utente.email },
          { withCredentials: true }
        );

        this.lastInvitationLink = response.data.invitation_link || "";
        if (this.lastInvitationLink) {
          await this.copyInvitationLink(this.lastInvitationLink, {
            silent: true,
          });
        }

        this.successModalMessaggio = response.data.invitation_email_sent
          ? `Invito reinviato via email a ${utente.email}.`
          : `Invio invito non riuscito per ${utente.email}. Riprova tra poco.`;
        this.successModalVisibile = true;
        this.fetchDataCompleta();
      } catch (error) {
        this.erroreRegistrazione =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Errore durante il reinvio dell'invito.";
      }
    },

    chiediConfermaAggiorna(utente) {
      this.utenteSelezionato = utente;
      this.modalTitolo = "Conferma aggiornamento utente";
      this.modalMessaggio = `Sei sicuro di voler aggiornare i dati per l'utente "${utente.email}"?`;
      this.azioneDaConfermare = "aggiornaUtente";
      this.modalVisibile = true;
    },

    chiediConfermaElimina(utente) {
      this.closeUserActionsMenu();
      this.utenteSelezionato = utente;
      this.modalTitolo = "Conferma eliminazione utente";
      this.modalMessaggio = `Sei sicuro di voler eliminare l'utente "${utente.email}"?`;
      this.azioneDaConfermare = "eliminaUtente";
      this.modalVisibile = true;
    },

    aggiornaRuoloUtente(utente) {
      axios
        .post(`${API_BASE_URL}/admin/update_utente`, {
          email: utente.email,
          ruolo: utente.ruolo,
          puo_fare_acquisti: utente.puo_fare_acquisti,
          can_manage_studio_settings: utente.can_manage_studio_settings,
        })
        .then((response) => {
          if (response.data) {
            utente.ruolo = response.data.nuovo_ruolo || utente.ruolo;
            utente.can_manage_studio_settings = Boolean(
              response.data.can_manage_studio_settings
            );
          }
          utente.ruolo_originale = utente.ruolo;
          utente.puo_fare_acquisti_originale = utente.puo_fare_acquisti;
          utente.can_manage_studio_settings_originale =
            utente.can_manage_studio_settings;

          this.successModalVisibile = true;
          this.successModalMessaggio = `Utente "${utente.email}" aggiornato con successo`;
        })
        .catch((err) => console.error(err));
    },

    confermaAzione() {
      if (this.azioneDaConfermare === "aggiornaUtente") {
        this.aggiornaRuoloUtente(this.utenteSelezionato);
      } else if (this.azioneDaConfermare === "eliminaUtente") {
        this.eliminaUtente(this.utenteSelezionato.email);
      }
      this.modalVisibile = false;
    },

    annullaAzione() {
      this.modalVisibile = false;
      this.azioneDaConfermare = null;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleUserActionsOutsideClick);
    window.addEventListener("scroll", this.closeTablePanels, true);
    window.addEventListener("resize", this.closeTablePanels);
    this.fetchDataCompleta();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleUserActionsOutsideClick);
    window.removeEventListener("scroll", this.closeTablePanels, true);
    window.removeEventListener("resize", this.closeTablePanels);
  },
};
</script>

<style scoped>
.info-icon-software {
  color: #2874a6;
  font-size: 0.85rem;
  transition: color 0.2s;
}

.info-icon-software:hover {
  color: #155f92;
}
.info-icon-operations {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  cursor: pointer;
  position: relative;
  font-weight: normal !important;
}
.info-icon-operations:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
.storico-btn {
  background: none;
  border: none;
  font-size: 1.45rem;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  transition: all 0.2s ease;
  position: relative;
}

.storico-btn:hover:not(.bloccato) {
  background-color: #e3f2fd;
  transform: scale(1.12);
}

.storico-btn.bloccato {
  color: #bdc3c7 !important;
  cursor: default;
  opacity: 0.6;
}

.storico-btn.bloccato:hover {
  background: none !important;
  transform: none !important;
}
.registration-date-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  width: 100%;
}
.conversioni-cell {
  position: relative;
  display: inline-flex;
  justify-content: center;
  width: 100%;
}
.conversioni-total {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  min-width: 3rem;
  padding: 0.2rem 0.5rem;
  border: 1px solid #c9d8e6;
  border-radius: 999px;
  background: #f8fafc;
  color: #102a43;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}
.conversioni-total:hover,
.conversioni-total:focus {
  border-color: #b8d7f3;
  background: #e8f3fc;
  outline: none;
}
.conversioni-popover {
  position: fixed;
  z-index: 1000;
  min-width: 12.5rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid #d9e2ec;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(16, 42, 67, 0.18);
  color: #102a43;
  text-align: left;
}
.conversioni-popover strong {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.9rem;
}
.conversioni-popover span {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.12rem 0;
  white-space: nowrap;
}
.header {
  margin-right: 1rem;
  display: flex;
  gap: 16px;
  padding-top: 1rem;
  align-items: baseline;
  align-content: center;
  justify-content: center;
  margin-bottom: 0rem !important;
}
.container-area-personale {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.studio-management-page {
  --studio-left-offset: 2rem;
  --studio-right-offset: 2rem;
  --studio-navbar-reserved-height: 92px;
  --studio-sidebar-width: 16.75rem;
  display: grid;
  grid-template-columns: var(--studio-sidebar-width) minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);

  align-items: stretch;
  justify-content: start;
  column-gap: 1rem;
  row-gap: 0;

  box-sizing: border-box;
  width: 100%;

  height: calc(100dvh - var(--studio-navbar-reserved-height));
  max-height: calc(100dvh - var(--studio-navbar-reserved-height));
  min-height: 0;

  margin-inline: 0;
  padding: 1.1rem clamp(1rem, 5vw, 6rem) 1rem;
  overflow: hidden;
  background: #f7f9fb;
}

.area-page-header {
  position: relative;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.9rem;
  width: 100%;
  min-height: 5.85rem;
  padding: 0.72rem 12rem 0.72rem 1rem;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid rgba(102, 123, 140, 0.14);
  border-radius: 12px;
  background: linear-gradient(105deg, #f7f9fa 0%, #eff3f6 68%, #e7edf2 100%);
  box-shadow: 0 7px 20px rgba(64, 83, 99, 0.06);
}

.area-page-header__icon {
  position: relative;
  z-index: 1;
  display: block;
  width: 3.7rem;
  height: 3.7rem;
  flex: 0 0 3.7rem;
  object-fit: contain;
}

.area-page-header__icon--section {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: linear-gradient(145deg, #e8f6ef, #dcefe6);
  color: #07815e;
  font-size: 1.55rem;
}

.area-page-header__copy {
  position: relative;
  z-index: 1;
  min-width: 0;
  text-align: left;
}

.area-page-header__title {
  margin: 0;
  color: #15334b;
  font-size: 1.42rem;
  font-weight: 750;
  letter-spacing: -0.015em;
  line-height: 1.15;
}

.area-page-header__subtitle {
  margin: 0.3rem 0 0;
  color: #657c88;
  font-size: 0.82rem;
  line-height: 1.35;
}

.area-page-header__visual {
  position: absolute;
  z-index: 0;
  display: block;
  pointer-events: none;
  user-select: none;
}

.area-page-header__visual--management {
  right: 1.2rem;
  bottom: -2.5rem;
  width: 11.2rem;
  opacity: 0.56;
}

.studio-management-sidebar {
  grid-column: 1;
  grid-row: 1;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 1rem 0.5rem;
  border: 1px solid #dfe7ef;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 14px 34px rgba(15, 37, 55, 0.07);
  overflow: hidden;
}
.studio-sidebar-hero {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.7rem;
  padding: 0.2rem 0.3rem 0.85rem;
  text-align: left;
}
.studio-sidebar-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  flex: 0 0 3rem;
  border-radius: 999px;
  background: radial-gradient(
    circle at 35% 25%,
    #fafbfc 0,
    #f1f3f5 58%,
    #e8ecef 100%
  );
  color: #354968;
  font-size: 1.35rem;
}
.studio-sidebar-icon i {
  color: #5f7890;
}
.studio-sidebar-hero h3 {
  margin: 0;
  color: #13243f;
  font-size: 1.12rem;
  line-height: 1.15;
}
.studio-sidebar-divider {
  height: 1px;
  margin: 0 0 0.55rem;
  background: #dfe7ef;
}

.studio-sidebar-navigation,
.studio-sidebar-admin-navigation {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}

.studio-sidebar-navigation {
  flex: 1 1 auto;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
}

.studio-sidebar-admin-navigation {
  margin-top: 0.7rem;
}

.studio-sidebar-nav-item {
  display: flex;
  width: 100%;
  min-height: 3rem;
  align-items: center;
  gap: 0.6rem;
  box-sizing: border-box;
  padding: 0.62rem 0.5rem;
  border: 0;
  border-left: 3px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #34495e;
  font: inherit;
  font-size: 0.88rem;
  font-weight: 650;
  line-height: 1.2;
  text-align: left;
  cursor: pointer;
  transition: color 0.18s ease, background 0.18s ease, border-color 0.18s ease;
}

.studio-sidebar-nav-item i {
  width: 1.25rem;
  flex: 0 0 1.25rem;
  color: #49677f;
  font-size: 1rem;
  text-align: center;
  transition: color 0.18s ease;
}

.studio-sidebar-nav-item span {
  min-width: 0;
  white-space: nowrap;
}

.studio-sidebar-nav-item:hover {
  background: #f2f7f5;
  color: #087552;
}

.studio-sidebar-nav-item:hover i,
.studio-sidebar-nav-item.active i {
  color: #07815e;
}

.studio-sidebar-nav-item.active {
  border-left-color: #07815e;
  background: linear-gradient(90deg, #e5f5ed 0%, #eef8f4 100%);
  color: #087552;
}

.studio-sidebar-nav-section-label {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin: 0.15rem 0.2rem 0.2rem;
  color: #728295;
  font-size: 0.58rem;
  font-weight: 750;
  letter-spacing: 0.11em;
  line-height: 1;
  text-transform: uppercase;
}

.studio-sidebar-nav-section-label::after {
  content: "";
  height: 1px;
  flex: 1 1 auto;
  background: #dfe7ef;
}
.studio-sidebar-summary,
.studio-sidebar-actions {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}
.studio-sidebar-card,
.studio-sidebar-actions button {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  width: 100%;
  box-sizing: border-box;
  padding: 0.78rem 0.85rem;
  border: 1px solid #edf1f5;
  border-radius: 10px;
  background: linear-gradient(135deg, #fbfcfd, #f2faf6);
  text-align: left;
}
.studio-sidebar-card i {
  width: 1.4rem;
  flex: 0 0 1.4rem;
  color: #0b7d55;
  font-size: 1.3rem;
  text-align: center;
}
.studio-sidebar-card span {
  display: block;
  color: #52657a;
  font-size: 0.78rem;
  line-height: 1.15;
}
.studio-sidebar-card strong {
  display: block;
  margin-top: 0.12rem;
  color: #087a3e;
  font-size: 1rem;
  line-height: 1.15;
}
.studio-sidebar-card--plan > i,
.studio-sidebar-card--plan strong {
  color: #c18300;
}
.studio-sidebar-card--plan,
.studio-sidebar-card--coin {
  background: linear-gradient(135deg, #f6f7f8, #e8ecef);
}
.studio-sidebar-card--plan strong,
.studio-sidebar-card--coin strong {
  font-family: "Inter", "Segoe UI Variable Text", "Segoe UI", sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: -0.025em;
}
.studio-sidebar-card--plan-plus > i,
.studio-sidebar-card--plan-plus strong {
  color: #1d5fb8;
}
.studio-sidebar-card--plan-base > i,
.studio-sidebar-card--plan-base strong {
  color: #64748b;
}
.studio-sidebar-card--coin > i {
  color: #b97900;
}

.studio-sidebar-card--coin strong {
  color: #c18300;
}
.studio-sidebar-card--users > i,
.studio-sidebar-card--users span,
.studio-sidebar-card--users strong {
  color: #46515e;
}
.studio-sidebar-card--users {
  background: linear-gradient(135deg, #fbfcfd, #f1f3f5);
}

.studio-sidebar-card.studio-sidebar-card--plan,
.studio-sidebar-card.studio-sidebar-card--coin {
  background: linear-gradient(135deg, #fbfcfd, #f1f3f5);
}

.studio-sidebar-card.studio-sidebar-card--plan > i,
.studio-sidebar-card.studio-sidebar-card--plan span,
.studio-sidebar-card.studio-sidebar-card--plan strong,
.studio-sidebar-card.studio-sidebar-card--coin > i,
.studio-sidebar-card.studio-sidebar-card--coin span,
.studio-sidebar-card.studio-sidebar-card--coin strong {
  color: #46515e;
}

.studio-sidebar-actions {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #dfe7ef;
}
.studio-sidebar-actions button {
  position: relative;
  height: 3.25rem;
  min-height: 3.25rem;
  color: #20324c;
  font: inherit;
  font-size: 0.86rem;
  font-weight: 650;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease;
}
.studio-sidebar-actions button:hover {
  border-color: #cfe1ef;
  background: #f5faf8;
}
.studio-sidebar-actions button.active {
  border-color: #b9d8c9;
  background: linear-gradient(135deg, #eef8f3, #e7f4ed);
  color: #0b6f4d;
}
.studio-sidebar-actions button i {
  color: #13243f;
}
.studio-sidebar-actions button span {
  flex: 1 1 auto;
}
.sidebar-copy-feedback {
  flex: 0 0 auto;
}

.studio-account-panel {
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: auto;
  padding: 0.2rem;
  box-sizing: border-box;
}

.studio-account-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid rgba(111, 134, 151, 0.2);
  border-radius: 1.25rem;
  background: #fff;
  box-shadow: 0 12px 30px rgba(20, 42, 58, 0.1);
}

.studio-account-header {
  display: flex;
  align-items: center;
  padding: 0.9rem 1.5rem;
  border-bottom: 1px solid #e4eaee;
  background: linear-gradient(115deg, #f5f9fb, #eaf1f5);
}

.studio-account-header > div {
  min-width: 0;
  flex: 1 1 auto;
  text-align: left;
}

.studio-account-header h2 {
  margin: 0;
  text-align: left;
}

.studio-account-header h2 {
  color: #1d3445;
  font-size: 1.08rem;
}

.studio-account-body {
  display: grid;
  flex: 1 1 auto;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-content: start;
  gap: 1rem;
  padding: 1.5rem;
}

.studio-account-field {
  display: grid;
  min-width: 0;
  gap: 0.4rem;
}

.studio-account-location-grid,
.studio-account-feedback {
  grid-column: 1 / -1;
}

.studio-account-location-grid {
  display: grid;
  grid-template-columns: 0.75fr 1.5fr 0.65fr;
  gap: 1rem;
}

.studio-account-field label {
  color: #334c5e;
  font-size: 0.86rem;
  font-weight: 750;
}

.studio-account-field input {
  width: 100%;
  min-height: 2.85rem;
  box-sizing: border-box;
  padding: 0.7rem 0.85rem;
  border: 1px solid #cfdbe2;
  border-radius: 0.7rem;
  background: #fbfcfd;
  color: #203746;
  font: inherit;
}

.studio-account-field input:focus {
  border-color: #5f96b8;
  outline: 0;
  box-shadow: 0 0 0 3px rgba(95, 150, 184, 0.14);
}

.studio-account-uppercase {
  text-transform: uppercase;
}

.studio-account-feedback {
  margin: 0;
  padding: 0.75rem 0.9rem;
  border-radius: 0.65rem;
  background: #fff1f1;
  color: #a42e2e;
  font-size: 0.88rem;
}

.studio-account-actions {
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  gap: 0.7rem;
  padding: 1rem 1.5rem 1.3rem;
  border-top: 1px solid #e7ecef;
}

.studio-account-actions button {
  min-height: 2.7rem;
  padding: 0.65rem 1rem;
  border-radius: 0.7rem;
  font-weight: 750;
  cursor: pointer;
}

.studio-account-actions button:disabled {
  cursor: default;
  opacity: 0.55;
}

.studio-account-secondary {
  border: 1px solid #ccd8df;
  background: #fff;
  color: #496071;
}

.studio-account-primary {
  border: 1px solid #477fa2;
  background: #527f9d;
  color: #fff;
}
.copy-feedback {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.44rem;
  border: 1px solid #cbe9dc;
  border-radius: 999px;
  background: #edf8f3;
  color: #0b7d55;
  font-size: 0.68rem;
  font-style: normal;
  font-weight: 750;
  line-height: 1;
  white-space: nowrap;
  pointer-events: none;
}
.studio-management-main {
  grid-column: 2;
  grid-row: 1;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-width: 0;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}
.studio-management-content {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  height: 0;
  min-height: 0;
  align-items: stretch;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid #dfe7ef;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 37, 55, 0.07);
}
.studio-panel-viewport {
  flex: 1 1 0;
  width: 100%;
  max-width: 100%;
  height: 0;
  min-height: 0;
  padding: 1rem 1.2rem 1.2rem;
  box-sizing: border-box;
  overflow: hidden;
}
.main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 100%;
  min-height: 0;
}
.fa-user-tie {
  font-size: 2rem;
  color: rgb(33, 105, 81);
}
.pricing-form {
  margin-top: -0.5rem;
  margin-bottom: 3rem;
  padding: 1.5rem;
  border: 1px solid #b2b2b2;
  border-radius: 8px;
  background-color: #f9f9f9;
  width: 26rem;
  box-sizing: border-box;
}
.pricing-form .mb-2 {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
}
.input-wrapper {
  position: relative;
}
.input-note {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.7rem;
  color: #666;
  pointer-events: none;
}
.pricing-form label {
  flex: 0 0 58%;
  text-align: left;
  font-weight: bold;
}
.pricing-form input {
  flex: 0 0 40%;
  max-width: 8.5rem;
  padding: 0.4rem 0.5rem;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.pricing-form button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 0.5rem;
}
.user-registration-form {
  box-sizing: border-box;
}
.registration-modal {
  width: min(40rem, calc(100vw - 2rem));
  padding: 0;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);
  border: 1px solid #dbe4ee;
}
.registration-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.5rem 2rem 1rem;
  border-bottom: 1px solid #e5edf5;
  background: #f8fafc;
}
.registration-modal-header > div {
  flex: 1;
}
.formtitle {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin: 0;
  font-size: 1.3rem;
  color: #1e293b;
}
.formsubtitle {
  margin: 0.4rem 0 0;
  padding-left: 2.15rem;
  color: #64748b;
  font-size: 0.95rem;
  text-align: left;
}
.registration-close-btn {
  background: none;
  border: none;
  color: #64748b;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.5rem;
  line-height: 1;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.registration-close-btn:hover {
  background: #fee2e2;
  color: #ef4444;
}
.registration-banner {
  margin: 1.25rem 2rem 0;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  text-align: left;
  font-size: 0.95rem;
}
.registration-banner.error {
  background: #fee2e2;
  color: #b91c1c;
  border-left: 4px solid #ef4444;
}
.registration-banner.success {
  background: #ecfdf3;
  color: #166534;
  border-left: 4px solid #22c55e;
}
.registration-modal-form {
  padding: 1.5rem 2rem 2rem;
}
.registration-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}
.registration-password-grid {
  margin-top: 0.25rem;
}
.registration-info-box {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin: 0.25rem 0 1.15rem;
  padding: 0.9rem 1rem;
  color: #0f5132;
  background: #effaf3;
  border: 1px solid #b7e4c7;
  border-radius: 12px;
  line-height: 1.45;
  text-align: left;
}
.registration-info-box i {
  margin-top: 0.15rem;
  color: #166534;
}
.invite-link-panel {
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  z-index: 1500;
  max-width: min(560px, calc(100vw - 3rem));
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 1rem;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 14px;
  box-shadow: 0 14px 35px rgba(15, 81, 50, 0.18);
  color: #14532d;
}
.invite-link-panel p {
  margin: 0.2rem 0 0.45rem;
}
.invite-link-panel code {
  display: block;
  max-width: 380px;
  padding: 0.45rem 0.55rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
}
.invite-link-panel button {
  border: 0;
  border-radius: 10px;
  padding: 0.65rem 0.9rem;
  color: #fff;
  background: #2e7d32;
  font-weight: 700;
  cursor: pointer;
}
.convert-test-modal input {
  width: 100%;
  box-sizing: border-box;
  margin: 0.35rem 0;
  padding: 0.65rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
}

.convert-test-modal p {
  text-align: left;
}

.convert-test-error {
  margin: 0.5rem 0 0;
  color: #b91c1c;
  font-weight: 700;
}
.user-status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 5.5rem;
  padding: 0.32rem 0.55rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
}
.user-status-badge.pending {
  color: #92400e;
  background: #fef3c7;
}
.user-status-badge.test {
  color: #1e3a8a;
  background: #dbeafe;
}
.user-status-badge.active {
  color: #166534;
  background: #dcfce7;
}
.user-status-badge.legacy {
  color: #374151;
  background: #e5e7eb;
}
.registration-field {
  margin-bottom: 1.15rem;
  text-align: left;
}
.registration-field label {
  display: block;
  margin-bottom: 0.45rem;
  font-weight: 500 !important;
  font-size: 0.95rem;
  color: #374151;
}
.required {
  color: #ef4444;
}
.registration-field input {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0.8rem 1rem;
  font-size: 0.98rem;
  color: #0f172a;
  background: #fff;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
}
.registration-field input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}
.registration-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-top: 1.75rem;
}
.registration-btn {
  min-height: 2.75rem;
  padding: 0.75rem 1.35rem;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease,
    box-shadow 0.2s ease;
}
.registration-btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
  transform: none;
  box-shadow: none;
}
.registration-btn.cancel {
  background: #e5e7eb;
  color: #374151;
}
.registration-btn.cancel:hover:not(:disabled) {
  background: #d1d5db;
}
.registration-btn.primary {
  background: #2563eb;
  color: #fff;
  min-width: 12.5rem;
}
.registration-btn.primary:hover:not(:disabled) {
  background: #1d4ed8;
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.22);
}
.registration-loading-label {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
}
.registration-spinner {
  width: 15px;
  height: 15px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  display: inline-block;
  animation: spin 0.8s linear infinite;
}
button.toggle-form-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 2.05rem;
  background-color: #145da0;
  color: white;
  padding: 0.42rem 0.72rem;
  font-size: 0.84rem;
  font-weight: 600;
  border: 1px solid #145da0;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(20, 93, 160, 0.2);
  transition: background-color 0.2s ease, border-color 0.2s ease,
    box-shadow 0.2s ease, transform 0.2s ease;
}
button.toggle-form-btn:hover:not(.active) {
  background-color: #0f4f8c;
  border-color: #0f4f8c;
  box-shadow: 0 3px 8px rgba(20, 93, 160, 0.22);
  transform: translateY(-1px);
}
button.toggle-form-btn.active {
  background-color: #0f4f8c;
}
.controlli-wrapper {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
}
.password-container {
  position: relative;
}
.password-container input {
  position: relative;
  padding-right: 2.9rem;
}
.toggle-password-icon {
  position: absolute;
  top: calc(50% + 0.85rem);
  right: 1rem;
  transform: translateY(-50%);
  cursor: pointer;
  color: #94a3b8;
  font-size: 1rem;
  transition: color 0.3s ease;
}
.password-container input:focus + .toggle-password-icon,
.toggle-password-icon:hover {
  color: #475569;
}
.toggle-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  margin: 0 auto 1rem auto;
  width: fit-content;
}
.toggle-buttons button {
  flex: 1;
  background-color: #e0e0e0;
  color: #333;
  border: 1px solid #ccc;
  padding: 0.5rem;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.toggle-buttons button.active {
  background-color: #007bff;
  color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}
.toggle-buttons button:not(.active):hover {
  background-color: #b2b2b2;
}
.admin-panel-tabs {
  position: relative;
  flex: 0 0 auto;
  align-self: stretch;
  width: auto;
  display: flex;
  gap: 0;
  justify-content: flex-start;
  margin: 1rem 1.2rem 0;
  padding: 0;
  box-sizing: border-box;
  border: 0;
  border-radius: 10px;
  background: #f5f7f8;
  overflow-x: auto;
  overflow-y: hidden;
}
.admin-panel-tabs::after {
  content: none;
}
.admin-panel-tabs > .admin-panel-tab {
  flex: 1 1 0;
}
.admin-panel-admin-group {
  flex: 2 1 0;
  position: relative;
  display: flex;
  align-items: stretch;
  gap: 0;
  margin-left: 0;
  padding-left: 0.2rem;
  border-left: 1px solid #d9e1e6;
}
.admin-panel-admin-group .admin-panel-tab {
  flex: 1 1 0;
  justify-content: center;
}
.admin-panel-admin-label {
  position: absolute;
  top: 0.35rem;
  left: 29%;
  color: #718096;
  font-size: 0.52rem;
  font-weight: 600;
  letter-spacing: 0.09em;
  line-height: 1;
  text-transform: uppercase;
  white-space: nowrap;
  pointer-events: none;
}
.admin-only-tab {
  position: relative;
  color: #354f68;
  padding-top: 1.05rem !important;
  padding-bottom: 0.3rem !important;
}
.embedded-panel {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
.embedded-panel-card {
  display: flex;
  height: 100%;
  flex-direction: column;
  min-height: 0;
  padding: 1.25rem;
  border: 1px solid #dfe7ef;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 37, 55, 0.07);
  box-sizing: border-box;
}
.admin-panel-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  box-sizing: border-box;
  background: transparent;
  color: #44546a;
  border: none;
  border-bottom: 3px solid transparent;
  padding: 0.65rem 0.8rem;
  min-height: 3.2rem;
  font-family: inherit;
  font-size: 0.92rem;
  font-weight: 600;
  line-height: 1.15;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}
.admin-panel-tab:hover {
  color: #0b7d55;
  background: #f4faf7;
}
.admin-panel-tab.active {
  color: #0b7d55;
  border-bottom-color: #0b7d55;
  background: linear-gradient(90deg, #eaf7f0, #f1faf6);
}
.admin-panel-tab i {
  font-size: 1.05rem;
  line-height: 1;
}
.studio-panel {
  width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  justify-content: center;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}
.studio-files-section {
  width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: 0;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}
.table-wrapper {
  display: flex;
  gap: 0.5rem;
}
.controlli-btn {
  padding: 0.2rem;
}
.modal-content {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  max-width: 350px;
  text-align: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
}
.btn {
  padding: 0.5rem 1rem;
  margin: 0 0.3rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.btn-confirm {
  background-color: #007bff;
  color: white;
}
.btn-cancel {
  background-color: #ccc;
  color: #333;
}
.btnannulla {
  background-color: #ccc !important;
  color: #333 !important;
}
.table-container {
  width: 90%;
  margin: 0 auto;
}
.table-container2 {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}
.users-table-scroll {
  flex: 1 1 0;
  height: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #e2e6ea;
  border-radius: 12px;
  background: #ffffff;
}
.usertable {
  width: 100%;
  max-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 0;
  table-layout: fixed;
  margin: 0;
}
.usertable th,
.usertable td {
  box-sizing: border-box;
  border: 1px solid #e2e6ea;
  padding: 0.55rem 0.45rem;
}
.usertable td:not(:last-child) {
  overflow: hidden;
  text-overflow: ellipsis;
}
.usertable td:last-child {
  overflow: visible;
}
.usertable th {
  position: sticky;
  top: 0;
  z-index: 5;
  text-align: center;
  font-size: 0.82rem;
  color: #13243f;
  background: #f3f4f6;
  background-clip: padding-box;
  box-shadow: 0 -1px 0 #f3f4f6, 0 1px 0 #dfe5eb;
}
.usertable tbody tr:nth-child(odd) td {
  background: #ffffff;
}
.usertable tbody tr:nth-child(even) td {
  background: #f8f9fa;
}
.usertable td:nth-child(1),
.usertable th:nth-child(1) {
  width: 9%;
}
.usertable td:nth-child(2),
.usertable th:nth-child(2) {
  width: 24%;
}
.usertable td:nth-child(3),
.usertable th:nth-child(3) {
  width: 7%;
}
.usertable td:nth-child(4),
.usertable th:nth-child(4) {
  width: 9%;
}
.usertable td:nth-child(5),
.usertable th:nth-child(5) {
  width: 13%;
}
.usertable td:nth-child(6),
.usertable th:nth-child(6) {
  width: 11%;
}
.usertable td:nth-child(7),
.usertable th:nth-child(7) {
  width: 8%;
}
.usertable td:nth-child(8),
.usertable th:nth-child(8) {
  width: 10%;
}
.usertable td:nth-child(9),
.usertable th:nth-child(9) {
  width: 9%;
}
.download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 2.05rem;
  background-color: #fff;
  color: #2f4156;
  padding: 0.42rem 0.72rem;
  border: 1px solid #d6dee8;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.84rem;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  transition: background-color 0.2s ease, border-color 0.2s ease,
    box-shadow 0.2s ease, transform 0.2s ease;
}
.download-btn:hover {
  background-color: #f4f8fc;
  border-color: #bdd1e5;
  box-shadow: 0 3px 8px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.modal-content {
  background: white;
  padding: 20px;
  max-width: 400px;
  border-radius: 10px;
}
.modal-button-row {
  display: flex;
  justify-content: center;
  gap: 1.2rem;
  margin-top: 1.5rem;
}
.modal-btn-close {
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  background-color: #868686 !important;
}
.modal-btn-close:hover {
  background-color: #747474 !important;
}
.modal-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  min-width: 8rem;
  text-align: center;
}
.modal-btn:hover {
  background-color: #0056b3;
}
.link-button {
  background: none;
  border: none;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.crediti-wrapper {
  height: 44px;
  margin: 0.5rem 0;
}
.hiddenInput {
  opacity: 0;
  height: 0;
  pointer-events: none;
}
.studio-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.studio-info h2 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  border-bottom: 2px solid #3498db;
  padding-bottom: 0.3rem;
}
.studio-detail-row {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e0e0e0;
}
.studio-detail-row:last-child {
  border-bottom: none;
}
.label {
  font-weight: 600;
  color: #34495e;
}
.value {
  font-weight: 400;
  color: #555;
  position: relative;
}
.tabletitle {
  margin: 0;
  font-size: 1.12rem;
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
}
.tabletitle i {
  color: #34495e;
  font-size: 1.1rem;
}
.tabletitle {
  margin: 0;
  color: #17243d;
  text-align: left;
}
.table-header {
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 0.7rem;
  padding: 0.75rem 1rem;
  border: 1px solid #dfe7ef;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 37, 55, 0.06);
}
.table-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.4rem;
  flex-wrap: wrap;
}
.table-actions i {
  font-size: 0.9rem;
  line-height: 1;
}
.modal-overlay2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(15, 23, 42, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 1rem;
}
.modal-content2 {
  background: white;
  border-radius: 10px;
  position: relative;
}
@media (max-width: 720px) {
  .registration-modal-header,
  .registration-modal-form {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .registration-grid {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .registration-actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }
  .registration-btn.primary {
    min-width: 0;
  }
}
select {
  padding: 0.1rem;
}
label {
  font-weight: 400 !important;
}
input[type="number"] {
  -moz-appearance: textfield;
  -webkit-appearance: none;
  appearance: none;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
.input-modificato {
  border: 1px solid #0dad23;
  background-color: #cee9cb;
  transition: all 0.3s ease;
}
.admin-fixed {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.18rem 0.42rem;
  border-radius: 6px;
  background: #f5f5f5;
  color: #555;
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
}
.info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0px;
  margin-left: 3px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  position: relative;
  transform: translateY(-1px);
}
.info-icon2 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0px;
  margin-left: 3px;
  width: 14px;
  height: 14px;
  text-align: center;
  font-size: 10px;
  color: #555;
  border: 1px solid #363636;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  transform: translateY(-1px);
}
.info-icon2:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
.modal-content-storico {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  position: relative;
  max-height: 80vh;
  overflow-y: auto;
}
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: none;
  font-size: 1.5rem;
  cursor: pointer;
}
.storico-btn {
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
  background: transparent;
  border: none;
  color: #2874a6;
  font-size: 1.2rem;
}
.storico-btn:hover {
  background-color: #e0f0ff;
  color: #007bff;
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}
.download-log-table {
  width: 65rem;
  border-collapse: collapse;
  font-size: 0.95rem;
}
.download-log-table thead {
  background-color: #f0f0f0;
}
.download-log-table th {
  text-align: center !important;
}
.download-log-table th,
.download-log-table td {
  padding: 0.75rem;
  border: 1px solid #ddd;
  text-align: left;
  overflow-wrap: break-word;
}
.download-log-table th:nth-child(1),
.download-log-table td:nth-child(1) {
  width: 25%;
}
.download-log-table th:nth-child(2),
.download-log-table td:nth-child(2) {
  width: 25%;
}
.download-log-table th:nth-child(3),
.download-log-table td:nth-child(3) {
  width: 34%;
}
.download-log-table th:nth-child(4),
.download-log-table td:nth-child(4) {
  width: 16%;
  text-align: center;
}
.expanded-row {
  padding-top: 1em !important;
}
.operationtext {
  text-align: center !important;
  font-style: italic;
  color: #666;
  height: 2rem;
}
.chip {
  display: inline-block;
  background-color: #eef1f5;
  padding: 4px 8px;
  border-radius: 12px;
  color: #333;
  transition: background-color 0.2s ease;
}
.chip:hover {
  background-color: #dbe5f0;
}
.clickable-cell {
  cursor: pointer;
  color: #0056b3;
}
.loader-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.studio-skeleton {
  box-sizing: border-box;
  padding: 2rem;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 0;
  margin-top: 1.5rem;
  width: min(100%, 60rem) !important;
  min-height: 34rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.skeleton {
  background-color: #e0e0e0;
  height: 20px;
  border-radius: 4px;
  animation: pulse 1.5s infinite ease-in-out;
}
.skeleton.title {
  width: 60%;
  height: 24px;
  align-self: flex-start;
}
.skeleton.row {
  width: 20rem;
  align-self: flex-start;
}
.skeleton.row.short {
  width: 40%;
  align-self: flex-start;
}
.admin-dashboard-skeleton {
  max-width: 60rem;
}
.admin-skeleton-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 0.5rem;
  margin-left: 1rem;
}
.admin-skeleton-icon {
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  flex: 0 0 1.75rem;
}
.admin-skeleton-heading-lines {
  width: min(24rem, 70%);
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}
.admin-skeleton-title {
  width: 70%;
  height: 1.45rem;
}
.admin-skeleton-subtitle {
  width: 86%;
  height: 0.95rem;
}
.admin-skeleton-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.admin-skeleton-section:not(:last-child) {
  padding-bottom: 1.2rem;
  border-bottom: 1px solid #34495e35;
}
.admin-skeleton-section-title {
  width: 12rem;
  height: 1rem;
}
.admin-skeleton-card-row {
  display: flex;
  gap: 1.2rem;
  width: 100%;
  min-width: 0;
}
.admin-skeleton-card {
  box-sizing: border-box;
  flex: 1 1 20%;
  min-width: 0;
  padding: 1rem;
  border-radius: 6px;
  background-color: #f9f9f9;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}
.admin-skeleton-card-label {
  width: 78%;
  height: 0.95rem;
  margin: 0 auto 0.8rem;
}
.admin-skeleton-card-value {
  width: 42%;
  height: 1.25rem;
  margin: 0 auto;
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.skeleton-cell {
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s infinite ease-in-out;
  width: 100%;
}
.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.slider::before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  border-radius: 50%;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: #5f96c2;
}
input:checked + .slider::before {
  transform: translateX(22px);
}
.slider.modificato {
  box-shadow: 0 0 0 1px #0dad23;
}
input:checked + .slider.modificato {
  background-color: #0dad23;
}
input:not(:checked) + .slider.modificato {
  background-color: #cee9cb;
}
.save-all-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 2.05rem;
  background-color: #fff;
  color: #256a46;
  border: 1px solid #c7dfd0;
  padding: 0.42rem 0.72rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.84rem;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  transition: background-color 0.2s ease, border-color 0.2s ease,
    box-shadow 0.2s ease, transform 0.2s ease;
}
.save-all-btn:hover:not(:disabled) {
  background-color: #eef8f1;
  border-color: #9fc9af;
  box-shadow: 0 3px 8px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}
.save-all-btn:disabled {
  background-color: #f4f6f8;
  border-color: #dde3ea;
  color: #9aa5b1;
  box-shadow: none;
  opacity: 1;
  cursor: default;
}
.modal-overlay-key {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.modal-content-key {
  background: white;
  padding: 20px 30px;
  border-radius: 8px;
  width: 26rem;
  text-align: center;
}
.keystudio {
  font-family: monospace;
  font-size: 1.2rem;
  padding: 0.7rem;
  color: #2e7d32;
}
.edit-key-form {
  margin: 10px 0;
}
.edit-key-form label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  text-align: left;
}
.edit-key-form .input-field {
  width: 25rem;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}
.modal-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}
.modal-btn-edit,
.modal-btn-save,
.modal-btn-close {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}
.modal-btn-edit,
.modal-btn-save {
  background-color: #4caf50;
  color: white;
}
.modal-btn-edit:hover,
.modal-btn-save:hover {
  background-color: #45a049;
}
.modal-btn-close:hover {
  background-color: #b0b0b0;
}
.modal-btn-save:disabled {
  opacity: 0.8;
  pointer-events: none;
  background-color: #cccccc;
}
.error-message {
  color: red;
  font-weight: bold;
  margin-bottom: 10px;
}
.success-message {
  color: green;
  font-weight: bold;
  margin-bottom: 10px;
}
.spinner {
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-top: 3px solid #fff;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  animation: spin 0.8s linear infinite;
  display: inline-block;
  margin-right: 8px;
  vertical-align: middle;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.studio-dashboard {
  flex: 1 1 0;
  width: 100%;
  max-width: none;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #dfe7ef;
  border-radius: 14px;
  box-shadow: 0 12px 30px rgba(15, 37, 55, 0.07);
  padding: 1.65rem 1.75rem;
  margin: 0;
  overflow: auto;
}

.studio-title-wrapper {
  display: flex;
  align-items: center;
  margin: 0 0 1.35rem;
  gap: 14px;
  color: #34495e;
}
.studio-title-wrapper > i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 12px;
  background: #e8f7ef;
  color: #0b7d55;
  font-size: 1.45rem;
}

.studio-icon {
  font-size: 2.4rem;
  color: #3498db;
}

.studio-name {
  font-size: 1.5rem;
  margin: 0;
  text-align: left;
}

.studio-sub {
  font-size: 0.95rem;
  color: #777;
  margin-top: 2px;
  margin-bottom: 0;
  text-align: left;
}

.studio-stats {
  display: flex;
  flex-direction: column;
  gap: 0.95rem;
}
.stat-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.95rem;
  width: 100%;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #dfe7ef;
}
.title-cards {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-align: left;
  margin: 0;
  color: #20324c;
  font-size: 1.02rem;
  font-weight: 750;
}
.title-cards::after {
  content: "";
  flex: 1 1 auto;
  height: 1px;
  background: #dfe7ef;
}
.stat-card {
  min-width: 0;
  height: 6.1rem;
  min-height: 6.1rem;
  box-sizing: border-box;
  background-color: #fbfcfd;
  border: 1px solid #edf1f5;
  border-radius: 10px;
  padding: 1rem;
  text-align: left;
  box-shadow: none;
}
.stat-card-iconic {
  display: grid;
  grid-template-columns: 2.2rem minmax(0, 1fr);
  grid-template-rows: auto auto;
  align-content: center;
  align-items: center;
  column-gap: 1rem;
}
.stat-card-documents {
  column-gap: calc(1.4rem + 2px);
}
.stat-card-iconic .stat-icon {
  grid-row: 1 / 3;
  color: #29425d;
  font-size: 2rem;
  text-align: center;
}
.stat-card-iconic .stat-label,
.stat-card-iconic .stat-value {
  grid-column: 2;
}
.stat-card-link {
  color: inherit;
  font: inherit;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease, transform 0.18s ease;
}
.stat-card-link:hover {
  border-color: #c3dacf;
  background: linear-gradient(145deg, #f3f8f6, #eaf4ef);
  box-shadow: 0 7px 16px rgba(15, 71, 50, 0.1);
  transform: translateY(-1px);
}
.stat-card-link:focus-visible {
  outline: 3px solid rgba(11, 125, 85, 0.22);
  outline-offset: 2px;
}
.stat-card-iconic .studio-aggregate-icon {
  position: relative;
  display: inline-flex;
  width: 3.1rem;
  height: 2.85rem;
  align-items: flex-end;
  justify-content: center;
  overflow: visible;
}
.studio-aggregate-folder {
  position: relative;
  z-index: 2;
  margin-bottom: 0.05rem;
  font-size: 2rem;
}
.studio-aggregate-tools {
  position: absolute;
  top: -0.4rem;
  left: 50%;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  gap: 0.16rem;
  transform: translateX(-50%);
}
.studio-aggregate-tools .product-icon {
  width: 1.08rem;
  height: 1.08rem;
  border-radius: 3px;
  background: #f8fafb;
  box-shadow: 0 1px 3px rgba(24, 48, 72, 0.16);
}
.studio-aggregate-tools .product-icon:first-child {
  transform: translateY(0.22rem) rotate(-9deg);
}
.studio-aggregate-tools .product-icon:nth-child(2) {
  transform: translateY(-0.05rem);
}
.studio-aggregate-tools .product-icon:last-child {
  transform: translateY(0.22rem) rotate(9deg);
}
.stat-card-plan-highlight,
.stat-card-coin-highlight {
  background: linear-gradient(135deg, #f6f7f8, #e8ecef);
}

.stat-card-statistiche {
  grid-template-columns: 3rem minmax(0, 1fr);
  min-height: 6.1rem;
  padding: 0.85rem;
  column-gap: 0.75rem;
  border: 0;
  border-radius: 8px;
  background: linear-gradient(145deg, #f8fafb, #f2f4f6);
}

.stat-card-statistiche--converter {
  border: 1px solid var(--stat-metric-border);
  background: linear-gradient(145deg, var(--stat-metric-soft), #f8fafb 78%);
}

.stat-card-statistiche--prospetti {
  --stat-metric-accent: #16885f;
  --stat-metric-strong: #076247;
  --stat-metric-soft: rgba(22, 136, 95, 0.11);
  --stat-metric-border: rgba(22, 136, 95, 0.16);
}

.stat-card-statistiche--f24 {
  --stat-metric-accent: #168bd2;
  --stat-metric-strong: #075994;
  --stat-metric-soft: rgba(22, 139, 210, 0.1);
  --stat-metric-border: rgba(22, 139, 210, 0.16);
}

.stat-card-statistiche--bilanci {
  --stat-metric-accent: #b77909;
  --stat-metric-strong: #795006;
  --stat-metric-soft: rgba(183, 121, 9, 0.1);
  --stat-metric-border: rgba(183, 121, 9, 0.16);
}

.stat-card-statistiche--converter.stat-card-iconic .stat-icon {
  display: inline-flex;
  width: 3rem;
  height: 3rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.72rem;
  background: transparent;
  color: var(--stat-metric-accent);
  box-shadow: none;
}

.stat-card-statistiche--converter .stat-icon .product-icon {
  width: 88%;
  height: 88%;
  transform: scale(1.12);
}

.stat-card-statistiche .stat-label {
  min-height: 0;
  margin-bottom: 0;
  color: #536477;
  font-size: 0.94rem;
  font-weight: 700;
  line-height: 1.2;
  white-space: normal;
}

.stat-card-statistiche .stat-value {
  margin-top: 0.35rem;
  color: #0b9a35;
  font-size: 1.55rem;
  font-weight: 600;
  line-height: 1;
}

.stat-card-statistiche--converter .stat-value {
  color: var(--stat-metric-strong);
}

.stat-card-documents .stat-value {
  color: #29425d;
}

.stat-card-registrazione .stat-value {
  color: #686868;
}

.stat-card-registrazione {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stat-card-registrazione .stat-label {
  font-size: 0.94rem;
}

.stat-label {
  display: block;
  font-weight: 600;
  color: #52657a;
  margin-bottom: 0.5rem;
  font-size: 0.86rem;
}

.stat-value {
  font-size: 1.22rem;
  color: #17243d;
  font-weight: 750;
}
.studio-users-trigger {
  display: inline-flex;
  width: fit-content;
  align-self: flex-start;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
  padding: 0.2rem 0.65rem;
  border: 1px solid #c9d8e6;
  border-radius: 999px;
  background: #ffffff;
  color: #145da0;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease,
    box-shadow 0.2s ease;
}
.studio-users-trigger:hover,
.studio-users-trigger:focus-visible {
  border-color: #83b8e8;
  background: #eef6fd;
  box-shadow: 0 0 0 3px rgba(47, 128, 237, 0.12);
  outline: none;
}
.studio-users-modal {
  width: min(32rem, calc(100vw - 2rem));
  max-height: min(38rem, calc(100vh - 3rem));
  overflow: hidden;
  border: 1px solid #dbe4ee;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 20px 55px rgba(15, 23, 42, 0.24);
}
.studio-users-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.4rem;
  border-bottom: 1px solid #e5edf5;
  background: #f8fafc;
  text-align: left;
}
.studio-users-modal-header h3,
.studio-users-modal-header p {
  margin: 0;
}
.studio-users-modal-header h3 {
  color: #1e293b;
  font-size: 1.2rem;
}
.studio-users-modal-header p {
  margin-top: 0.3rem;
  color: #64748b;
  font-size: 0.9rem;
}
.studio-users-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}
.studio-users-close:hover,
.studio-users-close:focus-visible {
  background: #e8eef5;
  color: #1e293b;
  outline: none;
}
.studio-users-list {
  max-height: 28rem;
  margin: 0;
  padding: 0.65rem;
  overflow-y: auto;
  list-style: none;
}
.studio-users-list li {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0.85rem;
  border-radius: 8px;
  color: #334155;
  text-align: left;
  overflow-wrap: anywhere;
}
.studio-users-list li:nth-child(even) {
  background: #f8fafc;
}
.studio-users-avatar {
  width: 2.75rem;
  height: 2.75rem;
  flex-basis: 2.75rem;
}
.studio-users-profile {
  flex: 1 1 auto;
}
.studio-users-profile strong {
  font-size: 0.94rem;
}
.studio-users-profile small {
  font-size: 0.82rem;
}
.studio-users-empty {
  margin: 0;
  padding: 2rem 1.4rem;
  color: #64748b;
  text-align: center;
}

/* Card speciale per la chiave */
.key-card {
  position: relative;
  border: 1px solid #dfe6ec;
  background-color: #f8fbff;
}

.key-actions {
  display: flex;
  align-items: center;
  gap: 0.62rem;
  margin-top: 0.5rem;
}

.key-icon,
.copy-icon {
  margin-left: 0;
  cursor: pointer;
  font-size: 1.1rem;
  color: #52657a;
  transition: color 0.2s;
}

.key-icon:hover,
.copy-icon:hover {
  color: #20324c;
}

.copy-message {
  margin-left: 0.05rem;
}

/* Tooltip (riutilizzabile) */
.info-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  font-style: normal;
  font-weight: bold;
  width: 16px;
  height: 16px;
  cursor: pointer;
  transform: translateY(-1px);
}
.info-icon-clean {
  border: 0;
  color: inherit;
  line-height: 1;
}

.info-icon .tooltip {
  visibility: hidden;
  background-color: #2c3e50;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 6px 10px;
  position: absolute;
  z-index: 10;
  bottom: 125%;
  left: 50%;
  margin-left: -110px;
  opacity: 0;
  transition: opacity 0.3s;
  font-weight: normal;
  font-size: 0.85rem;
}

.info-icon:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
.fa-briefcase {
  font-size: 1.75rem;
}
.table-wrapper.azioni-compatte {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

/* Stile base pulsanti icona */
.btn-azione {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #555;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.18s ease;
  position: relative;
}

/* Hover + focus leggero e moderno */
.btn-azione:hover,
.btn-azione:focus {
  background: rgba(0, 0, 0, 0.06);
  color: #333;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}

.btn-azione:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* Aggiorna / Salva – verde tenue */
.btn-aggiorna {
  color: #8b8f8d;
}

.btn-aggiorna:hover,
.btn-aggiorna:focus {
  background: rgba(39, 174, 96, 0.12);
  color: #219653;
}

/* Elimina – rosso tenue */
.btn-test-user {
  color: #8b8f8d;
}

.btn-test-user:hover,
.btn-test-user:focus {
  background: rgba(30, 58, 138, 0.12);
  color: #1e3a8a;
}

.btn-elimina {
  color: #8b8f8d;
}

.btn-elimina:hover,
.btn-elimina:focus {
  background: rgba(231, 76, 60, 0.12);
  color: #c0392b;
}
.btn-azione::after {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  z-index: 10;
}

.btn-azione:hover::after {
  opacity: 1;
}
.btn-menu-utente::after,
.btn-menu-utente:hover::after,
.btn-menu-utente:focus::after {
  content: none !important;
  display: none !important;
  opacity: 0 !important;
}

.archived-file-link {
  border: 0;
  background: transparent;
  color: #1d4ed8;
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-decoration: underline;
}

.archived-file-link.disabled {
  color: #7b8794;
  cursor: not-allowed;
  text-decoration: none;
}

.archived-files-message {
  margin-top: 0.8rem;
  color: #7c5c00;
  font-size: 0.95rem;
}

.compact-date-col {
  width: 11rem;
}

.compact-conversions-col {
  width: 8rem;
}

.actions-menu-wrapper {
  position: relative;
  display: inline-flex;
  justify-content: center;
}

.btn-menu-utente {
  width: 2rem;
}

.user-actions-dropdown {
  position: fixed;
  z-index: 1000;
  min-width: 12rem;
  max-height: calc(100vh - 1rem);
  overflow-y: auto;
  background: #fff;
  border: 1px solid #d7e2db;
  border-radius: 12px;
  box-shadow: 0 16px 36px rgba(15, 61, 46, 0.16);
}

.user-actions-dropdown button {
  display: block;
  width: 100%;
  padding: 0.7rem 0.9rem;
  border: 0;
  background: #fff;
  color: #0b2b46;
  cursor: pointer;
  font-size: 0.92rem;
  text-align: left;
}

.user-actions-dropdown button:hover:not(:disabled) {
  background: #f1f8f4;
}

.user-actions-dropdown button.danger {
  color: #b42318;
}

.user-actions-dropdown button:disabled {
  color: #a7a7a7;
  cursor: not-allowed;
}

.user-details-modal {
  max-width: 560px;
}

.user-details-grid {
  display: grid;
  grid-template-columns: minmax(160px, 1fr) minmax(0, 1.4fr);
  gap: 0.75rem 1rem;
  margin: 1rem 0;
  text-align: left;
}

.user-details-grid span {
  color: #66756d;
  font-weight: 700;
}

.user-details-grid strong {
  min-width: 0;
  overflow-wrap: anywhere;
  color: #0b2b46;
}

/* Toolbar Utenze: stessa grammatica visiva di Anagrafica Clienti. */
.table-header {
  gap: 0.5rem;
  margin-bottom: 0.85rem;
  padding: 0.5rem 0.75rem;
  border-color: #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.table-actions {
  gap: 0.5rem;
}

.table-actions-separator {
  align-self: stretch;
  width: 1px;
  min-height: 2rem;
  margin: 0 0.35rem;
  background: #d6dee8;
}

.table-actions > button.toggle-form-btn,
.table-actions > button.download-btn,
.table-actions > button.save-all-btn {
  min-height: auto;
  padding: 0.55rem 1.1rem;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #444;
  font-family: inherit;
  font-size: 0.94rem;
  font-weight: 500;
  box-shadow: none;
  transition: background-color 0.2s ease, box-shadow 0.2s ease,
    transform 0.2s ease;
}

.table-actions > button.toggle-form-btn:hover:not(:disabled),
.table-actions > button.download-btn:hover:not(:disabled),
.table-actions > button.save-all-btn:hover:not(:disabled) {
  border: 0;
  background: #f3f4f6;
  color: #444;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.table-actions > button.save-all-btn:disabled {
  border: 0;
  background: transparent;
  color: #a1a8b0;
  box-shadow: none;
  opacity: 0.72;
}

@media (min-width: 1101px) and (max-height: 940px) {
  .studio-management-page {
    --studio-navbar-reserved-height: 92px;
    padding-top: 0.75rem;
  }

  .area-page-header {
    min-height: 5.2rem;
    padding-top: 0.55rem;
    padding-bottom: 0.55rem;
  }

  .area-page-header__icon {
    width: 3.35rem;
    height: 3.35rem;
    flex-basis: 3.35rem;
  }

  .studio-management-sidebar {
    padding: 1rem 0.55rem;
  }

  .studio-sidebar-icon {
    width: 2.8rem;
    height: 2.8rem;
    flex-basis: 2.8rem;
  }

  .studio-sidebar-hero {
    gap: 0.5rem;
  }

  .studio-sidebar-divider {
    margin: 0 0 0.5rem;
  }

  .studio-sidebar-summary,
  .studio-sidebar-actions {
    gap: 0.55rem;
  }

  .studio-sidebar-card,
  .studio-sidebar-actions button {
    padding: 0.66rem 0.75rem;
  }

  .studio-sidebar-actions {
    margin-top: 0.7rem;
    padding-top: 0.7rem;
  }
}

@media (max-height: 940px) and (min-width: 1101px) {
  .studio-management-page {
    height: calc(100dvh - var(--studio-navbar-reserved-height));
    padding-top: 0.65rem;
    padding-bottom: 0.75rem;
  }

  .studio-management-sidebar {
    padding: 0.75rem 0.5rem;
  }

  .studio-sidebar-hero {
    gap: 0.45rem;
  }

  .studio-sidebar-icon {
    width: 2.65rem;
    height: 2.65rem;
    flex-basis: 2.65rem;
  }

  .studio-sidebar-hero h3 {
    font-size: 1.1rem;
  }

  .studio-sidebar-divider {
    margin: 0 0 0.45rem;
  }

  .studio-sidebar-summary,
  .studio-sidebar-actions {
    gap: 0.45rem;
  }

  .studio-sidebar-card,
  .studio-sidebar-actions button {
    padding: 0.55rem 0.65rem;
  }

  .studio-sidebar-actions {
    margin-top: 0.5rem;
    padding-top: 0.5rem;
  }

  .studio-dashboard {
    padding: 0.75rem 1rem;
    overflow: hidden;
  }

  .studio-title-wrapper {
    margin-bottom: 0.8rem;
    gap: 0.65rem;
  }

  .studio-title-wrapper > i {
    width: 2.15rem;
    height: 2.15rem;
    font-size: 1.2rem;
  }

  .studio-name {
    font-size: 1.28rem;
  }

  .studio-sub {
    font-size: 0.85rem;
  }

  .studio-stats {
    gap: 0.4rem;
  }

  .title-cards {
    font-size: 0.92rem;
    gap: 0.55rem;
  }

  .stat-row {
    gap: 0.6rem;
    padding-bottom: 0.55rem;
  }

  .stat-card {
    height: 5rem;
    min-height: 5rem;
    padding: 0.55rem 0.7rem;
  }

  .stat-card-statistiche {
    min-height: 5rem;
    padding: 0.75rem;
  }

  .stat-card-statistiche .stat-label {
    font-size: 0.84rem;
  }

  .stat-label {
    margin-bottom: 0.28rem;
    font-size: 0.78rem;
  }

  .stat-value {
    font-size: 1.04rem;
  }

  .stat-card-statistiche .stat-value {
    font-size: 1.25rem;
  }
}

@media (max-height: 740px) and (min-width: 1101px) {
  .studio-management-page {
    padding-top: 0.65rem;
    padding-bottom: 0.55rem;
  }

  .studio-dashboard {
    padding: 0.85rem 1rem;
  }

  .studio-sub {
    display: none;
  }

  .stat-card {
    padding: 0.55rem 0.7rem;
  }

  .stat-card-statistiche {
    padding: 0.55rem 0.7rem;
  }

  .stat-row {
    padding-bottom: 0.55rem;
  }
}

@media (min-width: 1101px) and (max-height: 900px) {
  .studio-management-page {
    row-gap: 0.6rem;
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
  }

  .area-page-header {
    min-height: 4.15rem;
    padding: 0.38rem 10rem 0.38rem 0.75rem;
    gap: 0.7rem;
  }

  .area-page-header__icon {
    width: 2.9rem;
    height: 2.9rem;
    flex-basis: 2.9rem;
  }

  .area-page-header__title {
    font-size: 1.2rem;
  }

  .area-page-header__subtitle {
    margin-top: 0.16rem;
    font-size: 0.74rem;
  }

  .area-page-header__visual--management {
    right: 0.9rem;
    bottom: -1.95rem;
    width: 8.7rem;
  }
}

@media (max-width: 1100px) {
  .studio-management-page {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    min-height: calc(100vh - 88px);
    margin-inline: 0;
    padding-right: clamp(1rem, 5vw, 6rem);
    padding-left: clamp(1rem, 5vw, 6rem);
    overflow: auto;
  }

  .area-page-header {
    flex: 0 0 auto;
  }

  .studio-management-sidebar {
    flex: 0 0 auto;
    width: 100%;
    max-height: none;
    overflow: auto;
  }

  .studio-sidebar-summary {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .studio-panel-viewport,
  .studio-panel,
  .embedded-panel,
  .table-container2,
  .studio-files-section,
  .studio-account-panel {
    height: auto;
    min-height: 28rem;
  }

  .stat-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 980px) {
  .studio-management-page {
    padding-right: 1rem;
    padding-left: 1rem;
  }
}

@media (max-width: 760px) {
  .area-page-header {
    min-height: 5.2rem;
    padding-right: 1rem;
  }

  .area-page-header__visual {
    display: none;
  }

  .studio-management-page {
    padding: 0.9rem 1rem;
  }

  .studio-account-body,
  .studio-account-location-grid {
    grid-template-columns: 1fr;
  }

  .studio-sidebar-summary,
  .stat-row {
    grid-template-columns: 1fr;
  }

  .table-header {
    align-items: flex-start;
    flex-direction: column;
  }
}

/* Utenze: directory compatta e coerente con il layout dell'Area Gestionale. */
.users-table-legacy {
  display: none;
}

.users-directory-header {
  flex: 0 0 auto;
  margin: 0;
  padding: 0.15rem 0.15rem 1rem;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.users-directory-header .tabletitle {
  gap: 0.65rem;
  color: #0d2348;
  font-size: 1.25rem;
  font-weight: 750;
}

.users-directory-header .tabletitle i {
  color: #102f63;
  font-size: 1.35rem;
}

.users-directory-header .table-actions {
  gap: 0.75rem;
}

.users-directory-header .table-actions-separator {
  display: none;
}

.users-directory-header .table-actions > button.toggle-form-btn,
.users-directory-header .table-actions > button.download-btn,
.users-directory-header .table-actions > button.save-all-btn {
  min-height: 2.8rem;
  padding: 0.65rem 1.15rem;
  border: 1px solid #d3deea;
  border-radius: 0.7rem;
  font-size: 0.9rem;
  font-weight: 650;
  white-space: nowrap;
}

.users-directory-header .table-actions > button.users-register-button {
  border-color: #07885f;
  background: linear-gradient(135deg, #13a373 0%, #07865e 100%);
  color: #fff;
  box-shadow: 0 5px 14px rgba(8, 137, 96, 0.16);
}

.users-directory-header
  .table-actions
  > button.users-register-button:hover:not(:disabled) {
  border-color: #067a55;
  background: linear-gradient(135deg, #0e9569 0%, #067a55 100%);
  color: #fff;
}

.users-directory-header .table-actions > button.download-btn {
  background: #fff;
  color: #163158;
}

.users-directory-header
  .table-actions
  > button.download-btn:hover:not(:disabled) {
  transform: none;
  border: 1px solid #b9cce0;
  background: #f6f9fc;
  color: #163158;
  box-shadow: 0 2px 6px rgba(15, 35, 66, 0.08);
}

.users-directory-header .table-actions > button.save-all-btn,
.users-directory-header .table-actions > button.save-all-btn:disabled {
  border-color: #e1e5ea;
  background: #f2f4f6;
  color: #aeb5c0;
  opacity: 1;
}

.users-directory-header .table-actions > button.save-all-btn:not(:disabled) {
  border-color: #b8dccc;
  background: #eaf7f1;
  color: #087a55;
}

.users-directory-body {
  display: flex;
  flex: 1 1 0;
  min-height: 0;
  flex-direction: column;
  padding: 1rem;
  border: 1px solid #dfe7ef;
  border-radius: 0.9rem;
  background: #fff;
}

.users-directory-toolbar {
  display: grid;
  flex: 0 0 auto;
  grid-template-columns: minmax(0, auto) minmax(0, 1fr);
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.users-directory-filters {
  display: grid;
  min-width: 0;
  grid-template-columns: minmax(0, 18rem) minmax(0, 10rem);
  justify-content: start;
  gap: 0.75rem;
}

.users-search-field,
.users-role-filter {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  min-height: 3rem;
  padding: 0 0.9rem;
  border: 1px solid #d4dfeb;
  border-radius: 0.7rem;
  background: #fff;
  color: #28486e;
}

.users-search-field i,
.users-role-filter i {
  flex: 0 0 auto;
  font-size: 1rem;
}

.users-search-field input,
.users-role-filter select {
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #233b5d;
  font: inherit;
  font-size: 0.88rem;
}

.users-search-field input::placeholder {
  color: #7c8da4;
  opacity: 1;
}

.users-directory-summary {
  display: grid;
  grid-template-columns: 8.6rem 8.6rem 11.2rem;
  justify-self: end;
  gap: 0.6rem;
}

.users-directory-actions {
  min-width: 0;
  justify-self: end;
  flex-wrap: nowrap;
  gap: 0.65rem;
}

.users-directory-actions > button.toggle-form-btn,
.users-directory-actions > button.download-btn,
.users-directory-actions > button.save-all-btn {
  min-height: 3rem;
  padding: 0.6rem 1rem;
  border: 1px solid #d3deea;
  border-radius: 0.7rem;
  font-family: inherit;
  font-size: 0.84rem;
  font-weight: 650;
  line-height: 1;
  white-space: nowrap;
  box-shadow: none;
  transform: none;
}

.users-directory-actions > button.users-register-button {
  border-color: #07885f;
  background: linear-gradient(135deg, #13a373 0%, #07865e 100%);
  color: #fff;
  box-shadow: 0 5px 14px rgba(8, 137, 96, 0.16);
}

.users-directory-actions > button.users-register-button:hover:not(:disabled) {
  transform: none;
  border: 1px solid #067a55;
  background: linear-gradient(135deg, #0e9569 0%, #067a55 100%);
  color: #fff;
}

.users-directory-actions > button.download-btn,
.users-directory-actions > button.download-btn:hover:not(:disabled) {
  transform: none;
  border: 1px solid #c9d7e5;
  background: #fff;
  color: #163158;
}

.users-directory-actions > button.download-btn:hover:not(:disabled) {
  border-color: #aebfd1;
  background: #f6f9fc;
}

.users-directory-actions > button.save-all-btn,
.users-directory-actions > button.save-all-btn:disabled {
  border: 1px solid #e1e5ea;
  background: #f2f4f6;
  color: #aeb5c0;
  opacity: 1;
}

.users-directory-actions > button.save-all-btn:not(:disabled) {
  border-color: #b8dccc;
  background: #eaf7f1;
  color: #087a55;
}

.users-summary-card {
  display: flex;
  min-width: 0;
  min-height: 3.35rem;
  align-items: center;
  gap: 0.55rem;
  padding: 0.45rem 0.65rem;
  border-radius: 0.65rem;
}

.users-summary-card--users {
  background: linear-gradient(135deg, #f1f6fd, #e8f1fc);
  color: #174b93;
}

.users-summary-card--admins {
  background: linear-gradient(135deg, #edf9f3, #e5f6ee);
  color: #087a55;
}

.users-summary-card--conversions {
  background: linear-gradient(135deg, #f7f2ff, #f0e9ff);
  color: #7040bf;
}

.users-summary-icon {
  display: inline-flex;
  width: 2.1rem;
  height: 2.1rem;
  flex: 0 0 2.1rem;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  font-size: 0.95rem;
}

.users-summary-card small,
.users-summary-card strong {
  display: block;
  line-height: 1.1;
}

.users-summary-card small {
  margin-bottom: 0.15rem;
  color: currentColor;
  font-size: 0.69rem;
  white-space: nowrap;
}

.users-summary-card strong {
  color: #0e294b;
  font-size: 1rem;
}

.users-directory-table-scroll {
  overflow: auto;
  border-color: #dce5ee;
  border-radius: 0.75rem;
}

.users-directory-table {
  min-width: 58rem;
  table-layout: fixed;
}

.users-directory-table th,
.users-directory-table td {
  padding: 0.7rem 0.75rem;
  border-width: 0 1px 1px 0;
  border-color: #e1e7ee;
  color: #294364;
  vertical-align: middle;
}

.users-directory-table th:last-child,
.users-directory-table td:last-child {
  border-right: 0;
}

.users-directory-table th {
  height: 3.2rem;
  text-align: left;
  color: #13294f;
  background: #f5f7fa;
  font-size: 0.85rem;
  font-weight: 750;
}

.users-directory-table th:first-child,
.users-directory-table th:last-child {
  text-align: center;
}

.users-directory-table tbody tr:nth-child(odd) td,
.users-directory-table tbody tr:nth-child(even) td {
  background: #fff;
}

.users-directory-table tbody tr:last-child td {
  border-bottom: 0;
}

.users-directory-table td:nth-child(1),
.users-directory-table th:nth-child(1) {
  width: 3.5%;
}

.users-directory-table td:nth-child(2),
.users-directory-table th:nth-child(2) {
  width: 25%;
}

.users-directory-table td:nth-child(3),
.users-directory-table th:nth-child(3) {
  width: 13.5%;
}

.users-directory-table td:nth-child(4),
.users-directory-table th:nth-child(4) {
  width: 21%;
}

.users-directory-table td:nth-child(5),
.users-directory-table th:nth-child(5) {
  width: 32%;
}

.users-directory-table td:nth-child(6),
.users-directory-table th:nth-child(6) {
  width: 5%;
}

.users-row-number {
  text-align: center;
  color: #6c7e96 !important;
  font-size: 0.78rem;
}

.users-profile-cell {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.85rem;
  text-align: left;
}

.users-profile-avatar {
  display: inline-flex;
  width: 3.05rem;
  height: 3.05rem;
  flex: 0 0 3.05rem;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 0.95rem;
  font-weight: 650;
}

.users-profile-avatar--1 {
  background: #e8f2ff;
  color: #2672c9;
}
.users-profile-avatar--2 {
  background: #e6f7ee;
  color: #07865e;
}
.users-profile-avatar--3 {
  background: #fff0df;
  color: #c36c23;
}
.users-profile-avatar--4 {
  background: #ffe9ef;
  color: #c34b6f;
}
.users-profile-avatar--5 {
  background: #def5f1;
  color: #08785d;
}

.users-profile-copy {
  display: block;
  min-width: 0;
  text-align: left;
}

.users-profile-copy strong,
.users-profile-copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.users-profile-copy strong {
  margin-bottom: 0.2rem;
  color: #0c244b;
  font-size: 0.86rem;
  font-weight: 750;
}

.users-profile-copy small {
  color: #617694;
  font-size: 0.78rem;
}

.users-role-select,
.users-role-fixed {
  display: flex;
  width: 100%;
  height: 2.55rem;
  min-height: 2.55rem;
  align-items: center;
  box-sizing: border-box;
  padding: 0.45rem 0.75rem;
  border: 1px solid #d3deea;
  border-radius: 0.65rem;
  background: #fff;
  color: #233b5d;
  font: inherit;
  font-size: 0.82rem;
}

.users-role-fixed {
  justify-content: flex-start;
  gap: 0.45rem;
  border-color: #f0c66f;
  background: linear-gradient(135deg, #fff4d6, #ffe5ae);
  color: #965800;
  font-size: 0.82rem;
  font-weight: 700;
  text-align: left;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);
}

.users-role-logo {
  display: block;
  width: 1.5rem;
  height: 1.5rem;
  flex: 0 0 1.5rem;
  object-fit: contain;
}

.users-role-select--admin {
  border-color: #b9cddd;
  background: linear-gradient(135deg, #f0f4f8, #dce8f2);
  color: #294b68;
  font-weight: 700;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);
}

.users-role-select.input-modificato,
select.input-modificato {
  border-color: #0dad23;
  background: linear-gradient(135deg, #eff9f0, #dcefd9);
  color: #236338;
  box-shadow: 0 0 0 1px rgba(13, 173, 35, 0.14);
}

.users-permissions-cell {
  display: grid;
  gap: 0.42rem;
}

.users-permission-row {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  color: #506987;
  font-size: 0.78rem;
  line-height: 1.15;
  white-space: nowrap;
}

.users-permission-row .switch {
  flex: 0 0 auto;
}

.users-activity-cell {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: center;
  gap: 0;
  overflow: visible;
}

.users-activity-cell > .conversioni-cell,
.users-activity-cell > .users-history-button {
  justify-self: center;
}

.users-registration-date {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 0.55rem;
  color: #506987;
  font-size: 0.79rem;
  white-space: nowrap;
}

.users-registration-date > i {
  color: #294b75;
  font-size: 1rem;
}

.users-conversions-pill {
  display: inline-flex;
  min-width: 0;
  min-height: 2rem;
  align-items: center;
  gap: 0.45rem;
  padding: 0.4rem 0.7rem;
  border: 0;
  border-radius: 999px;
  background: #eaf3ff;
  color: #166cc1;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.users-history-button {
  display: inline-flex;
  min-width: auto;
  min-height: 2rem;
  align-items: center;
  gap: 0.45rem;
  padding: 0.35rem 0.2rem;
  border: 0;
  background: transparent;
  color: #365372;
  font-size: 0.78rem;
  font-weight: 500;
  white-space: nowrap;
}

.users-history-button:hover:not(:disabled) {
  background: transparent;
  color: #087a55;
}

.users-history-button.bloccato {
  color: #96a2b1;
  opacity: 0.78;
}

.users-history-lock {
  font-size: 0.65rem;
}

.users-action-button {
  width: 2.5rem;
  height: 2.35rem;
  border: 1px solid #d3deea;
  border-radius: 0.65rem;
  background: #fff;
  color: #163158;
}

.users-empty-state {
  height: 7rem;
  text-align: center;
  color: #70839a !important;
}

.users-empty-state i {
  margin-right: 0.45rem;
}

@media (min-width: 1101px) and (max-height: 940px) {
  .users-directory-header {
    padding-bottom: 0.65rem;
  }

  .users-directory-header .table-actions > button.toggle-form-btn,
  .users-directory-header .table-actions > button.download-btn,
  .users-directory-header .table-actions > button.save-all-btn {
    min-height: 2.45rem;
    padding: 0.5rem 0.85rem;
    font-size: 0.8rem;
  }

  .users-directory-body {
    padding: 0.75rem;
  }

  .users-directory-toolbar {
    grid-template-columns: minmax(0, 28.5rem) minmax(0, 1fr);
    gap: 0.65rem;
    margin-bottom: 0.7rem;
  }

  .users-directory-filters {
    grid-template-columns: minmax(0, 17.5rem) minmax(0, 10rem);
    gap: 0.5rem;
  }

  .users-search-field,
  .users-role-filter {
    min-height: 2.55rem;
    gap: 0.6rem;
    padding-right: 0.7rem;
    padding-left: 0.7rem;
  }

  .users-directory-actions {
    gap: 0.4rem;
  }

  .users-directory-actions > button.toggle-form-btn,
  .users-directory-actions > button.download-btn,
  .users-directory-actions > button.save-all-btn {
    min-height: 2.55rem;
    padding: 0.5rem 0.65rem;
    font-size: 0.76rem;
  }

  .users-summary-card {
    min-height: 3rem;
    padding: 0.35rem 0.55rem;
  }

  .users-summary-icon {
    width: 1.9rem;
    height: 1.9rem;
    flex-basis: 1.9rem;
  }

  .users-directory-table th {
    height: 2.7rem;
  }

  .users-directory-table th,
  .users-directory-table td {
    padding-top: 0.45rem;
    padding-right: 0.5rem;
    padding-bottom: 0.45rem;
    padding-left: 0.5rem;
  }

  .users-directory-table-scroll {
    overflow-x: hidden;
  }

  .users-directory-table {
    width: 100%;
    min-width: 0;
  }

  .users-profile-avatar {
    width: 2.55rem;
    height: 2.55rem;
    flex-basis: 2.55rem;
  }
}

@media (max-width: 900px) {
  .users-directory-toolbar {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 760px) {
  .users-directory-header .table-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .users-directory-header .table-actions > button {
    flex: 1 1 12rem;
  }

  .users-directory-actions {
    width: 100%;
    justify-self: stretch;
    flex-wrap: wrap;
  }

  .users-directory-actions > button {
    flex: 1 1 12rem;
  }

  .users-directory-filters,
  .users-directory-summary {
    grid-template-columns: 1fr;
  }
}

/* Densità desktop compatta per notebook con viewport verticale ridotta. */
@media (min-width: 1101px) and (max-height: 850px) {
  .studio-management-page {
    --studio-sidebar-width: 15.5rem;

    column-gap: 0.9rem;
    row-gap: 0.54rem;
    padding-top: 0.54rem;
    padding-bottom: 0.54rem;
  }

  .area-page-header {
    min-height: 3.74rem;
    gap: 0.63rem;
    padding: 0.34rem 9rem 0.34rem 0.68rem;
  }

  .area-page-header__icon {
    width: 2.61rem;
    height: 2.61rem;
    flex-basis: 2.61rem;
  }

  .area-page-header__title {
    font-size: 1.08rem;
  }

  .area-page-header__subtitle {
    margin-top: 0.14rem;
    font-size: 0.67rem;
  }

  .area-page-header__visual--management {
    right: 0.8rem;
    bottom: -1.75rem;
    width: 7.83rem;
  }

  .studio-management-sidebar {
    padding: 0.68rem 0.45rem;
    border-radius: 14px;
  }

  .studio-sidebar-hero {
    gap: 0.4rem;
  }

  .studio-sidebar-icon {
    width: 2.55rem;
    height: 2.55rem;
    flex-basis: 2.55rem;
  }

  .studio-sidebar-hero h3 {
    font-size: 0.99rem;
  }

  .studio-sidebar-divider {
    margin: 0 0 0.4rem;
  }

  .studio-sidebar-summary,
  .studio-sidebar-actions {
    gap: 0.4rem;
  }

  .studio-sidebar-card,
  .studio-sidebar-actions button {
    gap: 0.72rem;
    padding: 0.5rem 0.58rem;
    border-radius: 9px;
  }

  .studio-sidebar-card i {
    width: 1.26rem;
    flex-basis: 1.26rem;
    font-size: 1.17rem;
  }

  .studio-sidebar-card span {
    font-size: 0.7rem;
  }

  .studio-sidebar-card strong {
    font-size: 0.9rem;
  }

  .studio-sidebar-card--plan strong,
  .studio-sidebar-card--coin strong {
    font-size: 0.86rem;
  }

  .studio-sidebar-actions {
    margin-top: 0.45rem;
    padding-top: 0.45rem;
  }

  .studio-sidebar-actions button {
    font-size: 0.77rem;
  }

  .admin-panel-tabs {
    margin: 0.9rem 1.08rem 0;
    border-radius: 9px;
  }

  .admin-panel-tab {
    min-height: 2.88rem;
    gap: 0.58rem;
    padding: 0.58rem 0.72rem;
    font-size: 0.83rem;
  }

  .admin-panel-tab i {
    font-size: 0.95rem;
  }

  .admin-panel-admin-label {
    top: 0.31rem;
    font-size: 0.47rem;
  }

  .admin-only-tab {
    padding-top: 0.94rem !important;
    padding-bottom: 0.27rem !important;
  }

  .studio-panel-viewport {
    padding: 0.9rem 1.08rem 1.08rem;
  }

  .embedded-panel-card {
    padding: 1.12rem;
    border-radius: 13px;
  }
}
</style>
